<template>
<div>
    <div class="card shadow p-0">
        <a id="button"></a>
        <div class="card-header bg-transparent">
             <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
            <!-- <button 
                    type="button"    
                    @click="hasHistory() 
                        ? $router.go(-1) 
                        : $router.push('/')" class="btn btn-secondary btn-sm">&laquo; 
                      {{$t('message.backtap')}}
                  </button> -->
            <h3 class="mb-0">
                {{ $t('message.edit') }} {{ $tc('message.generalConsultations', 1) }}
            </h3>
        </div>

        <b-container fluid class="p-0">
            <b-form @reset="onReset" v-if="show" class="p-0">
                <b-row>
                    
                    <b-col sm="12">
                        <span class="obligatoire">*</span>
                        <b-form-group id="timeLine-group" :label="$tc('message.TimelineSelect', 2)" label-for="timeLine" >
                            <multiselect v-model="$v.form.ligne_de_temps_id.$model" :options="lignetempsRows" :custom-label="nameLigne" :placeholder="$tc('message.TimelineSelect', 2)" @input="clearErrorField('ligne_de_temps_id')" selectLabel="Sélectionner" label="motif" track-by="id"></multiselect>
                                <!-- <select id="timeLine" v-model="$v.form.ligne_de_temps_id.$model" class="form-control is-invalid retirerBordure" @change="clearErrorField('ligne_de_temps_id')" required> -->
                                <!-- <option data-placeholder="true"></option>
                                <option v-for="item in lignetempsRows" :key="'timeLine'+item.id" :value="item.id">
                                    {{item.motif}} <b-badge variant="info">{{item.date}}</b-badge>
                                </option>
                                </select> -->
                            <b-form-invalid-feedback v-if="$v.form.ligne_de_temps_id.$error">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                            <span v-if="errorshasField('ligne_de_temps_id')" style="color:red">
                                {{getErrorsField('ligne_de_temps_id')}}
                            </span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="6" lg="6">
                        <span class="obligatoire">*</span>
                        <b-form-group id="institution-group" :label="$t('message.institutionConsultation')" label-for="institution">
                            <multiselect v-model="$v.form.etablissement_id.$model" :options="mInstitutions" :placeholder="$tc('message.institutionConsultation', 2)" @input="clearErrorField('etablissement_id')" selectLabel="Sélectionner" label="nom" track-by="id"></multiselect>
                            <!-- <select id="institution" v-model="$v.form.etablissement_id.$model" @change="clearErrorField('etablissement_id')" class="form-control is-invalid retirerBordure" required>
                                <option data-placeholder="true"></option>
                                <option v-for="item in mInstitutions" :key="'institution'+item.id" :value="item.id">
                                    {{ item.nom }}
                                </option>
                            </select> -->
                            <b-form-invalid-feedback v-if="$v.form.etablissement_id.$error">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                            <span v-if="errorshasField('etablissement_id')" style="color:red">
                                {{getErrorsField('etablissement_id')}}
                            </span>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="6">
                        <span class="obligatoire">*</span>
                        <b-form-group id="singleMotif-group" :label="$tc('message.reasons', 2)" label-for="singleMotif">
                            <multiselect v-model="$v.form.current_motifs.$model" :options="mReasons" :multiple="true" :placeholder="$tc('message.reasons', 2)" @input="clearErrorField('motifs')" selectLabel="Sélectionner" label="description" track-by="id"></multiselect>

                            <!-- <select id="singleMotif" v-model="$v.form.motifs.$model" multiple
                                    @change="clearErrorField('motifs')" class="form-control is-invalid retirerBordure" required
                            >
                                <option data-placeholder="true"></option>
                                <option v-for="item in mReasons" :key="'singleMotif'+item.value" :value="item.value">
                                {{ item.text }}
                                </option>
                            </select> -->
                            <!-- <b-form-invalid-feedback>
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback> -->
                            <span v-if="errorshasField('motifs')" style="color:red">
                                {{ getErrorsField('motifs') }}
                            </span>
                            </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="6">
                        <b-form-group id="contributors-group" :label="$tc('message.contributors',2)" label-for="contributors">
                            <multiselect v-model="$v.form.contributors.$model" :options="mContributors" :multiple="true" :placeholder="$tc('message.institutionConsultation', 2)" @input="clearErrorField('contributeurs')" selectLabel="Sélectionner" label="nom" track-by="id"></multiselect>
                        
                            <!-- <select id="contributors" v-model="$v.form.contributors.$model" @change="clearErrorField('contributeurs')" class="form-control is-invalid retirerBordure" required multiple>
                                <option data-placeholder="true"></option>
                                <option v-for="item in mContributors" :key="'contributors'+item.id" :value="item.id">
                                    {{ item.nom }}
                                </option>
                            </select> -->
                            <span v-if="errorshasField('contributeurs')" style="color:red">
                                {{getErrorsField('contributeurs')}}
                            </span>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="6" lg="6">
                        <span class="obligatoire">*</span>

                        <b-form-group id="consultation-group" :label="$t('message.consultationDate')" label-for="consultation" description="">
                            <b-form-input id="consultation" v-model="$v.form.date_consultation.$model" :state="$v.form.date_consultation.$dirty ? !(errorshasField('date_consultation') || $v.form.date_consultation.$error) : null" type="date" required @focus="clearErrorField('date_consultation')"></b-form-input>

                            <b-form-invalid-feedback v-if="!$v.form.date_consultation.required">
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="errorshasField('date_consultation')">
                                {{ getErrorsField('date_consultation') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>
                    <h3 >{{ $t('message.generale') }}</h3>
                </b-row>
                <b-tabs content-class="mt-2" fill v-if="!mobileView">
                    <b-tab :title="$t('message.settings')" active>
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group id="occupation-group" :label="$t('message.profession')" label-for="occupation-propose">
                                        <b-form-input id="occupation" v-model="$v.form.profession.$model" :state="$v.form.profession.$dirty ? !(errorshasField('profession') || $v.form.profession.$error) : null" @focus="clearErrorField('profession')"></b-form-input>

                                        <b-form-invalid-feedback v-if="errorshasField('profession')">
                                            {{ getErrorsField('profession') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="4">
                                    <b-form-group :label="$t('message.familyStuation')">
                                        <b-form-radio-group id="situation_familiale" v-model="$v.form.situation_familiale.$model" name="situation_familiale">
                                            <b-form-radio value="Marié(e)">{{$t('message.marie')}}</b-form-radio>
                                            <b-form-radio value="Celibataire">{{$t('message.celibataire')}}</b-form-radio>
                                        </b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <div :class="{ 'form-group--error': $v.form.nbre_enfant.$error}">
                                    <b-form-group
                                        id="nombreEnfant-group"
                                        :label="$t('message.nombreEnfant')"
                                        label-for="nombreEnfant"
                                    >
                                        <b-form-input
                                            id="nombreEnfant"
                                            v-model="$v.form.nbre_enfant.$model"
                                            :state="$v.form.nbre_enfant.$dirty ? !(errorshasField('nbre_enfant') || $v.form.nbre_enfant.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nbre_enfant')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.nbre_enfant.required">
                                        {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="!$v.form.nbre_enfant.email">
                                        {{ $t('message.emailNotValid') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    </div>
                                </b-col>                                            
                            </b-row>
                            <b-row :class="{ 'form-group--error': $v.form.tabac.$error}">

                                    <b-col >
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                        id="nbreCigarette-group"
                                        :label="$t('message.smokedPerDay')"
                                        label-for="nbreCigarette"
                                    >
                                        <b-form-input
                                            id="tabac"
                                            v-model="$v.form.nbreCigarette.$model"
                                            :state="$v.form.nbreCigarette.$dirty ? !(errorshasField('nbreCigarette') || $v.form.nbreCigarette.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nbreCigarette')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.nbreCigarette.required">
                                        {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    </b-col>
                                    <b-col>
                                    <span  class="obligatoire">*</span>
                                    <b-form-group
                                        id="nbreAnnee-group"
                                        :label="$t('message.numberOfYear')"
                                        label-for="nbreAnnee"
                                    >
                                        <b-form-input
                                            id="tabac2"
                                            v-model="$v.form.nbreAnnee.$model"
                                            :state="$v.form.nbreAnnee.$dirty ? !(errorshasField('nbreAnnee') || $v.form.nbreAnnee.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('tabac')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.nbreAnnee.required">
                                        {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    </b-col>
                                
                                <b-col sm="4">
                                    <div :class="{ 'form-group--error': $v.form.alcool.$error}">
                                    <b-form-group
                                        id="alcool-group"
                                        :label="$t('message.alcool')"
                                        label-for="alcool"
                                    >
                                        <b-form-input
                                            id="alcool"
                                            v-model="$v.form.alcool.$model"
                                            :state="$v.form.alcool.$dirty ? !(errorshasField('alcool') || $v.form.alcool.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('alcool')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.alcool.required">
                                        {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                    </div>
                                </b-col>

                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group id="autres-group" :label="$t('message.autres')" label-for="autres">
                                        <editor :api-key="tinyKey" id="autres" v-model="$v.form.autres.$model" :state="$v.form.autres.$dirty ? !(errorshasField('autres') || $v.form.autres.$error) : null" @focus="clearErrorField('autres')" :init="{
                                    height: 200,
                                    menubar: false,
                                    plugins: plugins,
                                    toolbar:toolbar
                                    }">
                                        </editor>

                                        <b-form-invalid-feedback v-if="errorshasField('autres')">
                                            {{ getErrorsField('autres') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        
                        <h3> {{ $t('message.anthropometrie') }}</h3>

                        <b-row>

                            <b-col sm="6">

                                <b-form-group id="poids-group" :label="$t('message.weight')" label-for="poids">
                                    <b-form-input id="reference" v-model="$v.form.poids.$model" :state="$v.form.poids.$dirty ? !(errorshasField('poids') || $v.form.poids.$error) : null" @focus="clearErrorField('poids')" type="number" step="0.01"></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.poids.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('poids')">
                                        {{ getErrorsField('poids') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group id="taille-group" :label="$t('message.height')" label-for="taille">
                                    <b-form-input id="taille" v-model="$v.form.taille.$model" :state="$v.form.taille.$dirty ? !(errorshasField('taille') || $v.form.taille.$error) : null" @focus="clearErrorField('taille')" type="number" step="0.01"></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.taille.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('taille')">
                                        {{ getErrorsField('taille') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>

                            <b-col sm="6">

                                <b-form-group id="circonferenceAbdominal-group" :label="$t('message.circonferenceAbdominal')" label-for="circonferenceAbdominal">
                                    <b-form-input id="reference" v-model="$v.form.circonferenceAbdominal.$model" :state="$v.form.circonferenceAbdominal.$dirty ? !(errorshasField('circonferenceAbdominal') || $v.form.circonferenceAbdominal.$error) : null" @focus="clearErrorField('circonferenceAbdominal')" type="number" step="0.01"></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.circonferenceAbdominal.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('circonferenceAbdominal')">
                                        {{ getErrorsField('circonferenceAbdominal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group id="circonferenceCranienne-group" :label="$t('message.circonferenceCranienne')" label-for="circonferenceCranienne">
                                    <b-form-input id="circonferenceCranienne" v-model="$v.form.circonferenceCranienne.$model" :state="$v.form.circonferenceCranienne.$dirty ? !(errorshasField('circonferenceCranienne') || $v.form.circonferenceCranienne.$error) : null" @focus="clearErrorField('circonferenceCranienne')" type="number" step="0.01"></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.circonferenceCranienne.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('circonferenceCranienne')">
                                        {{ getErrorsField('circonferenceCranienne') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <!-- <b-col sm="6">
                                <b-form-group id="bmi-group" :label="$t('message.bmi')" label-for="bmi">
                                    <b-form-input id="bmi" v-model="$v.form.bmi.$model" :state="$v.form.bmi.$dirty ? !(errorshasField('bmi') || $v.form.bmi.$error) : null" @focus="clearErrorField('bmi')" type="number" step="0.01"></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.bmi.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('bmi')">
                                        {{ getErrorsField('bmi') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col> -->
                        </b-row>                                    
                        <h3> {{ $t('message.signevitaux') }}</h3>
                        <b-row>

                            <b-col sm="6">

                                <b-form-group id="ta_systolique-group" :label="$t('message.taSystolique')" label-for="ta_systolique">
                                    <b-form-input id="ta_systolique" v-model="$v.form.ta_systolique.$model" :state="$v.form.ta_systolique.$dirty ? !(errorshasField('ta_systolique') || $v.form.ta_systolique.$error) : null" @focus="clearErrorField('ta_systolique')" type="number" step="0.01"></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.ta_systolique.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ta_systolique')">
                                        {{ getErrorsField('ta_systolique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group id="ta_diastolique-group" :label="$t('message.taDiastolique')" label-for="ta_diastolique">
                                    <b-form-input id="ta_diastolique" v-model="$v.form.ta_diastolique.$model" :state="$v.form.ta_diastolique.$dirty ? !(errorshasField('ta_diastolique') || $v.form.ta_diastolique.$error) : null" @focus="clearErrorField('ta_diastolique')" type="number" step="0.01"></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.ta_diastolique.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ta_diastolique')">
                                        {{ getErrorsField('ta_diastolique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col sm="6">

                                <b-form-group id="frequence_cardiaque-group" :label="$t('message.heartRate')" label-for="frequence_cardiaque">
                                    <b-form-input id="frequence_cardiaque" v-model="$v.form.frequence_cardiaque.$model" :state="$v.form.frequence_cardiaque.$dirty ? !(errorshasField('frequence_cardiaque') || $v.form.frequence_cardiaque.$error) : null" @focus="clearErrorField('frequence_cardiaque')" type="number" step="0.01"></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.frequence_cardiaque.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('frequence_cardiaque')">
                                        {{ getErrorsField('frequence_cardiaque') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group id="frequence_respiratoire-group" :label="$t('message.respiratoryRate')" label-for="frequence_respiratoire">
                                    <b-form-input id="frequence_respiratoire" v-model="$v.form.frequence_respiratoire.$model" :state="$v.form.frequence_respiratoire.$dirty ? !(errorshasField('frequence_respiratoire') || $v.form.frequence_respiratoire.$error) : null" @focus="clearErrorField('frequence_respiratoire')" type="number" step="0.01"></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.frequence_respiratoire.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('frequence_respiratoire')">
                                        {{ getErrorsField('frequence_respiratoire') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                            <b-col sm="6">

                                <b-form-group id="temperature-group" :label="$t('message.temperature')" label-for="temperature">
                                    <b-form-input id="temperature" v-model="$v.form.temperature.$model" :state="$v.form.temperature.$dirty ? !(errorshasField('temperature') || $v.form.temperature.$error) : null" @focus="clearErrorField('temperature')" type="number" step="0.01"></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.temperature.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('temperature')">
                                        {{ getErrorsField('temperature') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                            <b-col sm="6">

                                <b-form-group id="sato2-group" :label="$t('message.sato2')" label-for="sato2">
                                    <b-form-input id="sato2" v-model="$v.form.sato2.$model" :state="$v.form.sato2.$dirty ? !(errorshasField('sato2') || $v.form.sato2.$error) : null" @focus="clearErrorField('sato2')" type="number" step="0.01"></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.sato2.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('sato2')">
                                        {{ getErrorsField('sato2') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <h3>{{ $t('message.nutrition') }}</h3>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group>
                                    <b-form-checkbox  v-model="$v.form.malnutrition.$model" >{{ $t('message.malnutrition') }}</b-form-checkbox>
                                    <b-form-checkbox  v-model="$v.form.deshydratation.$model">{{ $t('message.deshydradation') }}</b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <h3>{{ $t('message.glucose') }}</h3>
                        <b-row>
                            <b-col sm="6">

                                <b-form-group id="glycemie-group" :label="$t('message.glycemie')" label-for="glycemie">
                                    <b-form-input id="glycemie" v-model="$v.form.glycemie.$model" :state="$v.form.glycemie.$dirty ? !(errorshasField('glycemie') || $v.form.glycemie.$error) : null" @focus="clearErrorField('glycemie')" type="number" step="0.01"></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.glycemie.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('glycemie')">
                                        {{ getErrorsField('glycemie') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group id="glycated-group" :label="$t('message.glycated')" label-for="glycated">
                                    <b-form-input id="glycated" v-model="$v.form.glycated.$model" :state="$v.form.glycated.$dirty ? !(errorshasField('glycated') || $v.form.glycated.$error) : null" @focus="clearErrorField('glycated')" type="number" step="0.01"></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.glycated.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('glycated')">
                                        {{ getErrorsField('glycated') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <h3>{{ $t('message.lipide') }}</h3>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group id="cholestorol-group" :label="$t('message.cholestorol')" label-for="cholestorol">
                                    <b-form-input id="cholestorol" v-model="$v.form.cholestorol.$model" type="number" step="0.01"></b-form-input>
                                </b-form-group>
                                <b-form-group id="ldl-group" :label="$t('message.ldl')" label-for="ldl">
                                    <b-form-input id="ldl" v-model="$v.form.ldl.$model" type="number" step="0.01"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group id="hdl-group" :label="$t('message.hdl')" label-for="hdl">
                                    <b-form-input id="hdl" v-model="$v.form.hdl.$model" type="number" step="0.01"></b-form-input>
                                </b-form-group>
                                <b-form-group id="tags-group" :label="$t('message.tags')" label-for="tags">
                                    <b-form-input id="tags" v-model="$v.form.tags.$model" type="number" step="0.01"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('message.infoAntecedents')">
                        <div id="antecedentForm">
                            <b-card-body v-if="antecedentsRows.length>0">
                                <vue-good-table id="antecedent" v-if="notEmpty(antecedentsRows)" :columns="antecedentsColumns" :rows="antecedentsRows" :search-options="enabled" :pagination-options="paginationOptions" :groupOptions="enabled" :sort-options="sort" @on-row-click="onAntecedentRowClick" />
                            </b-card-body>
                            <div class="shadow ">
                                <div class="container-perso" id="formAntecedent">
                                    <b-form @reset="onReset" v-if="show">
                                        <b-container>
                                            <b-row>
                                                <b-col sm="12">
                                                    <span class="obligatoire">*</span>

                                                    <b-form-group id="type-group" :label="$t('message.select')+' '+$tc('message.types',1)" label-for="type" class="mt-2">
                                                        <!-- Options -->
                                                        <select id="type" v-model="$v.antecedents.type.$model" class="form-control is-invalid retirerBordure" required :state="$v.antecedents.type.$dirty ? !(errorshasField('type') || $v.antecedents.type.$error) : null" @focus="clearErrorField('type')">
                                                            <option v-for="item in types" :value="item.value" :key="'type-group'+item.value">
                                                                {{ item.text }}
                                                            </option>
                                                        </select>

                                                        <b-form-invalid-feedback v-if="$v.antecedents.type.$error">
                                                            {{ $t('message.requiredField') }}
                                                        </b-form-invalid-feedback>

                                                        <b-form-invalid-feedback v-else-if="errorshasField('type')">
                                                            {{ getErrorsField('type') }}
                                                        </b-form-invalid-feedback>

                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="12">

                                                    <b-form-group id="date-group" :label="$t('message.startDate')" label-for="date">
                                                        <b-form-input id="date" v-model="$v.antecedents.date.$model" :state="$v.antecedents.date.$dirty ? !(errorshasField('date') || $v.allergiesForm.date.$error) : null" type="date" required @click="clearErrorField('date')"></b-form-input>

                                                        <b-form-invalid-feedback v-if="$v.antecedents.date.$error">
                                                            {{ $t('message.requiredField') }}
                                                        </b-form-invalid-feedback>
                                                        <span v-if="errorshasField('date')" style="color:red">
                                                            {{getErrorsField('date')}}
                                                        </span>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col sm="12">
                                                    <span class="obligatoire">*</span>

                                                    <b-form-group id="description-group" :label="$t('message.description')" label-for="description">
                                                        <b-form-textarea id="description" v-model="$v.antecedents.description.$model" :state="$v.antecedents.description.$dirty ? !(errorshasField('description') || $v.antecedents.description.$error) : null" required @focus="errorshasField('description')"></b-form-textarea>
                                                        <b-form-invalid-feedback v-if="!$v.antecedents.description.required">
                                                            {{ $t('message.requiredField') }}
                                                        </b-form-invalid-feedback>
                                                        <b-form-invalid-feedback v-if="!$v.antecedents.description.minLength">
                                                            {{ $t('message.minCharacters', { n: 3 }) }}
                                                        </b-form-invalid-feedback>
                                                        <b-form-invalid-feedback v-if="errorshasField('description')">
                                                            {{ getErrorsField('description') }}
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col sm="1">
                                                </b-col>
                                            </b-row>
                                            <b-row class="justify-content-sm-center mb-2" v-if="can">
                                                <b-button @click="onAntecedentSubmit" variant="primary">
                                                    {{ $t('message.save') }}
                                                </b-button>
                                                <!--                                                <a href="#retourConsultation" class="pt-2"> <i class="fas fa-angle-double-up"></i>  {{$t('message.back')}}</a>-->

                                            </b-row>
                                        </b-container>
                                    </b-form>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab :title="$t('message.infoAllergies')">
                        <div id="allergieForm">
                            <b-card-body v-if=" allergiesRows.length>0">
                                <vue-good-table id="allergie" v-if="notEmpty(allergiesRows)" :columns="allergiesColumns" :rows="allergiesRows" :search-options="enabled" :pagination-options="paginationOptions"/> <!--  @on-row-click="onAllergieRowClick" --> 
                            </b-card-body>
                            <div class="shadow">
                                <div class="container-perso" id="formAllergie">
                                    <b-form @reset="onReset" v-if="show">
                                        <b-container>
                                            <b-row>
                                                <b-col sm="12">
                                                    <span class="obligatoire">*</span>

                                                    <b-form-group id="type-group" :label="$t('message.add')+' '+$tc('message.description',1)" label-for="type" class="mt-2">
                                                        <!-- Options -->
                                                        <multiselect v-model="$v.allergiesForm.description.$model" :options="descriptions" :multiple="true" :placeholder="$t('message.add')+' '+$tc('message.description',1)" @input="clearErrorField('type')" selectLabel="Sélectionner" label="text" track-by="value"></multiselect>
                                                        <!-- <select id="allergies" v-model="$v.allergiesForm.description.$model" required class="form-control is-invalid retirerBordure" :state="$v.allergiesForm.description.$dirty ? !(errorshasField('type') || $v.allergiesForm.description.$error) : null" @focus="clearErrorField('type')" multiple>
                                                            <option data-placeholder="true"></option>
                                                            <option v-for="item in descriptions" :value="item.value" :key="'allergies'+item.value">
                                                                {{ item.text }}
                                                            </option>
                                                        </select> -->

                                                        <b-form-invalid-feedback v-if="$v.allergiesForm.description.$error">
                                                            {{ $t('message.requiredField') }}
                                                        </b-form-invalid-feedback>

                                                        <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                                            {{ getErrorsField('description') }}
                                                        </b-form-invalid-feedback>

                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row class="justify-content-sm-center mb-2" v-if="can">
                                                <b-button @click="onAllergieSubmit" variant="primary">
                                                    {{ $t('message.saveAllergie') }}
                                                </b-button>

                                            </b-row>
                                        </b-container>
                                    </b-form>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab :title="$t('message.currentTreatments')">    
                        <b-row>
                            <b-col sm="12">
                                <editor :api-key="tinyKey" id="traitementsACreer" :label="$t('message.currentTreatments')" label-for="traitements" @focus="clearErrorField('traitements')" v-model="$v.form.traitements.$model" :state="$v.form.traitements.$dirty ? !(errorshasField('traitements') || $v.form.traitements.$error) : null" :init="{
                                                height: 200,
                                                menubar: false,
                                                plugins: plugins,
                                                toolbar:toolbar
                                                }">
                                </editor>
                                <b-form-invalid-feedback v-if="errorshasField('traitements')">
                                    {{ getErrorsField('traitements') }}
                                </b-form-invalid-feedback>
                            </b-col>
                        </b-row>
                    </b-tab>
                    
                    
                    <b-tab :title="$t('message.anamnesis')">
                        <b-row>
                            <div v-for="(c,key) in anamneses" :key="key">
                                <b-form-group :label="key" v-slot="{ ariaDescribedby }">
                                    <b-form-checkbox-group name="anamneses" v-model="anamneseChecked" text-field="fr_description" :aria-describedby="ariaDescribedby" stacked>
                                        <b-form-checkbox v-for="(item, index) in c" :value="item" :key="'anamneses'+index" switch>
                                            <span>{{item.fr_description}}</span>
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>

                            </div>
                        </b-row>
                        
                        <b-row>
                                        <b-col sm="12">
    <b-form-group
        id="anamese-group"
        :label="$t('message.anamnesis')"
        label-for="anamese"
    >
        <editor
            :api-key="tinyKey"
            initialValue=""
            v-model="$v.form.anamese.$model"
            :state="$v.form.anamese.$dirty ? !(errorshasField('anamese') || $v.form.anamese.$error) : null"
            @focus="clearErrorField('anamese')"
            :init="{
                                    height: 200,
                                    menubar: false,
                                    plugins: plugins,
                                    toolbar:toolbar
                                }"
        >
        </editor>

        <b-form-invalid-feedback v-if="errorshasField('anamese')">
        {{ getErrorsField('anamese') }}
        </b-form-invalid-feedback>
    </b-form-group>
    </b-col>
        </b-row>
        </b-tab>
            <b-tab :title="$t('message.examenclinique')">
            <b-row>
                    <div v-for="(c,key) in examens" :key="'examenclinique'+key">
                                <b-form-group :label="key" v-slot="{ ariaDescribedby }">
                                    <b-form-checkbox-group name="examens" v-model="examenChecked" text-field="fr_description" :aria-describedby="ariaDescribedby" stacked switch>
                                        <b-form-checkbox v-for="(item, index) in c" :value="item" :key="'examens'+index">
                                            <span>{{item.fr_description}}</span>
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </div>
                        </b-row>
                        <b-row>
                                        <b-col sm="12">
    <b-form-group
        id="clinique-group"
        :label="$tc('message.physicalExams', 2)"
        label-for="clinique"
    >
        <editor
            :api-key="tinyKey"
            initialValue=""
            v-model="$v.form.examen_clinique.$model"
            :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"
            @focus="clearErrorField('examen_clinique')"
            :init="{
                                    height: 200,
                                    menubar: false,
                                    plugins: plugins,
                                    toolbar:toolbar
                                }"
        >
        </editor>
        <!--                                    <b-form-textarea-->
        <!--                                            id="clinique"-->
        <!--                                            v-model="$v.form.examen_clinique.$model"-->
        <!--                                            :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"-->
        <!--                                            rows="5"-->
        <!--                                            @focus="clearErrorField('examen_clinique')"-->
        <!--                                    ></b-form-textarea>-->

        <b-form-invalid-feedback v-if="errorshasField('examen_clinique')">
        {{ getErrorsField('examen_clinique') }}
        </b-form-invalid-feedback>
    </b-form-group>
    </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('message.examencomplementaire')">

                        <b-row>
                            <div v-for="(c,key) in complementaires" :key="'examencomplementaire'+key">
                                <b-form-group :label="key" v-slot="{ ariaDescribedby }">
                                    <div class="container">
                                        <div class="d-flex">
                                            <div class="overflow-auto p-2 mr-3" style=" max-height: 400px;">
                                                <b-form-checkbox-group name="complementaires" v-model="complementaireChecked" text-field="fr_description" :aria-describedby="ariaDescribedby" stacked switch>
                                                    <b-form-checkbox v-for="(item, index) in c" :value="item" :key="'complementaires'+index">
                                                        <span>{{item.fr_description}}</span>
                                                    </b-form-checkbox>
                                                </b-form-checkbox-group>
                                            </div>
                                        </div>
                                    </div>
                                </b-form-group>
                            </div>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                    id="complementaire-group"
                                    :label="$t('message.examencomplementaire')"
                                    label-for="complementaire"
                                    >
                                    <editor
                                        :api-key="tinyKey"
                                        initialValue=""
                                        v-model="$v.form.complementaire.$model"
                                        :state="
                                        $v.form.complementaire.$dirty
                                            ? !(
                                                errorshasField('complementaire') ||
                                                $v.form.complementaire.$error
                                            )
                                            : null
                                        "
                                        @focus="clearErrorField('complementaire')"
                                        :init="{
                                        height: 200,
                                        menubar: false,
                                        plugins: plugins,
                                        toolbar: toolbar,
                                        }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback
                                        v-if="errorshasField('complementaire')"
                                    >
                                        {{ getErrorsField("complementaire") }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('message.diagnostic')">

                        <b-row class="row ">
                            <b-col cols="8">
                                <div class="icd-instance">
                                <div class="icd">
                                    <!-- <div class="icd-search"> -->
                                    <input type="text" placeholder="Tapez votre recherche en Anglais" class="ctw-input" autocomplete="off" data-ctw-ino="1">
                                        <!-- <button class="icd-clear" :click="clear" title="Clear search and results">❌</button> -->
                                    <!-- </div>   -->
                                </div>
                                    Votre sélection est: <span id="icd-paste-selected-1"></span>
                                <div class="ctw-window" data-ctw-ino="1"></div>
                                </div>

                            </b-col>
                            <b-col cols="4">
                                
                                <div class="text-right appointment-item" >
                                    <div id="icd-selected-1">
                                        <table class="table table-responsive" >
                                                <thead>
                                                    <tr>
                                                    <th scope="col">ICD code</th>
                                                    <th scope="col">name</th>
                                                    <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(item,key) in slectedIcd" :key="key" class="mt-2">
                                                    <td>{{item.code}}</td>
                                                    <td> <p  style="">{{item.bestMatchText}}</p></td>
                                                    <td>
                                                        <b-button pill variant="danger" @click="remove(item.code)" size="sm">x</b-button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </b-col> 
                        </b-row>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group id="diagnostic-complementaire-group" :label="$t('message.diagnostic_complementaire')" label-for="diagnostic-complementaire">
                                    <editor :api-key="tinyKey" id="diagnostic_complementaire" v-model="$v.form.diagnostic_complementaire.$model" :state="$v.form.diagnostic_complementaire.$dirty ? !(errorshasField('diagnostic_complementaire') || $v.form.diagnostic_complementaire.$error) : null" @focus="clearErrorField('diagnostic_complementaire')" :init="{
                                                height: 200,
                                                menubar: false,
                                                plugins: plugins,
                                                toolbar:toolbar
                                                }">
                                    </editor>
                                    <b-form-invalid-feedback v-if="errorshasField('diagnostic_complementaire')">
                                        {{ getErrorsField('diagnostic_complementaire') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('message.cat')">
                        <b-col sm="12">
                            <b-form-group id="traitement-propose-group" :label="$t('message.cat')" label-for="traitement-propose">
                                <editor :api-key="tinyKey" id="traitement_propose" v-model="$v.form.traitement_propose.$model" :state="$v.form.traitement_propose.$dirty ? !(errorshasField('traitement_propose') || $v.form.traitement_propose.$error) : null" @focus="clearErrorField('traitement_propose')" :init="{
                                            height: 200,
                                            menubar: false,
                                            plugins: plugins,
                                            toolbar:toolbar
                                            }">
                                </editor>
                                <b-form-invalid-feedback v-if="errorshasField('traitement_propose')">
                                    {{ getErrorsField('traitement_propose') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-tab>
                    <b-tab :title="$t('message.infosupplementaire')">
                        <b-col sm="12">
                            <b-form-group id="information-group" label="Informations Supplémentaires" label-for="information">
                                <editor :api-key="tinyKey" id="information" v-model="$v.form.information.$model" :state="$v.form.information.$dirty ? !(errorshasField('information') || $v.form.information.$error) : null" @focus="clearErrorField('information')" :init="{
                                            height: 200,
                                            menubar: false,
                                            plugins: plugins,
                                            toolbar:toolbar
                                            }">
                                </editor>
                                <b-form-invalid-feedback v-if="errorshasField('information')">
                                    {{ getErrorsField('information') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-row>
                            <b-col sm="8">
                                <b-form-group id="upload-group" :label="$t('message.uploadFile')" label-for="upload">
                                    <b-form-file multiple type="file" accept=".jpeg, .png, .gif, .pdf, .docx" ref="file_input" id="upload" :state="$v.form.documents.$dirty ? !$v.form.documents.$error : null" :placeholder="$t('message.uploadFile')">
                                        <template slot="file-name" slot-scope="{ names }">
                                            <b-badge variant="dark">{{ names[0] }}</b-badge>
                                            <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                                                + {{ names.length - 1 }} More documents
                                            </b-badge>
                                        </template>
                                    </b-form-file>
                                    <span style="color: red" v-if="errorshasField('documents')">
                                        {{ getErrorsField('documents') }}
                                    </span>

                                    <span style="color: red" v-if="maxFileSize.length>0">{{ maxFileSize }}</span>

                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group id="u" label="." label-for="upload">
                                    <b-button @click="cleardocuments">{{ $t('message.emptyUpload') }}</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('message.rdv')">
                        <b-col sm="12">
                            <b-form-group id="date_rdv" :label="$t('message.appointmentDate')" label-for="appointmentDate">
                                <vue-ctk-date-time-picker class="border-dark" v-model="$v.form.dateRdv.$model"></vue-ctk-date-time-picker>
                            </b-form-group>

                        </b-col>
                        <b-col sm="12">
                            <b-form-group id="traitement-appointmentReason-group" :label="$t('message.appointmentReason')" label-for="appointmentReason">
                                <editor :api-key="tinyKey" id="appointmentReason" v-model="$v.form.motifRdv.$model" :init="{
                                            height: 200,
                                            menubar: false,
                                            plugins: plugins,
                                            toolbar:toolbar
                                            }">
                                </editor>
                            </b-form-group>
                        </b-col>
                        <b-row>
                            <b-col md="6" sm="12">
                                <b-form-group id="isConsultantDoctor-group" :label="$t('message.isConsultantDoctor')" label-for="isConsultantDoctor">
                                    <b-form-radio v-model="$v.form.isConsultantDoctor.$model" name="isConsultantDoctor" value="true" :inline="true">
                                        {{ $t('message.yes') }}
                                    </b-form-radio>
                                    <b-form-radio v-model="$v.form.isConsultantDoctor.$model" name="isConsultantDoctor" value="false" :inline="true">
                                        {{ $t('message.no') }}
                                    </b-form-radio>
                                    <b-form-invalid-feedback v-if="errorshasField('isConsultantDoctor')">
                                        {{ getErrorsField('isConsultantDoctor') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.isConsultantDoctor.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row v-if="form.isConsultantDoctor === 'false'" class="mt-3">
                            <b-col md="6" sm="12">
                                <b-form-group id="consultantDoctor-group" :label="$t('message.select')+' '+$tc('message.medecin',1)" label-for="patient">

                                    <b-form-radio v-model="$v.form.medecinSource.$model" name="medecinSource" value="fromMedicasure" :inline="true">
                                        {{ $t('message.fromMedicasure') }}
                                    </b-form-radio>
                                    <b-form-radio v-model="$v.form.medecinSource.$model" name="medecinSource" value="fromOthers" :inline="true">
                                        {{ $t('message.fromOthers') }}
                                    </b-form-radio>
                                    <!-- Options -->
                                    <multiselect v-if="form.medecinSource === 'fromMedicasure'" v-model="$v.form.practicien_id.$model" :options="mContributors" :multiple="true" :placeholder="$t('message.fromOthers')" selectLabel="Sélectionner" label="nom" track-by="id"></multiselect>
                                   <!--  <select  id="consultantDoctor" v-model="$v.form.practicien_id.$model" class="form-control is-invalid border-light mt-2">
                                        <option v-for="item in mContributors" :value="item.id" :key="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select> -->

                                    <b-form-input id="doctorName" class="mt-2" v-else v-model="$v.form.doctorName.$model" :placeholder="$t('message.preciseDoctorName')"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>

                </b-tabs>
                   <b-row v-else>
                    <div class="mobileUl w-100" >
                        <div class="mobileDropdown"  v-on:click="dropDown, dropHidden=true">
                            <p class="d-inline p-0 text-white">{{ $t('message.generale') }}</p>
                            <div class="mobileDropbtn d-inline p-0">
                            <a href="javascript:void(0)" class="fas text-white d-inline" v-on:click="dropDown, dropHidden=true">&#xf106;</a>          
                            </div>
                            <div class="medicalDropdown-content" id="myDropdown"  v-if="dropHidden">
                                <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isParam=true, isTraitement=false, isAnamnese=false, isXclinique = false, isXcomplement = false, isDiag = false, isCat = false, isRdv = false, dropHidden=false">
                                    <p>Paramètres</p>
                                </div>
                                <div class="p-2" @click="isInfo = false, isAllergie=true, isAntecedent=false, isParam=false, isTraitement=false, isAnamnese=false, isXclinique = false, isXcomplement = false, isDiag = false, isCat = false, isRdv = false, dropHidden=false">
                                    <p>Allergie</p>
                                </div>
                                <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=true, isParam=false, isTraitement=false, isAnamnese=false, isXclinique = false, isXcomplement = false, isDiag = false, isCat = false, isRdv = false, dropHidden=false">
                                    <p>Antécédents</p>
                                </div>
                                <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isParam=false, isTraitement=false, isAnamnese=true, isXclinique = false, isXcomplement = false, isDiag = false, isCat = false, isRdv = false, dropHidden=false">
                                    <p>Anamnèse</p>
                                </div>
                                <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isParam=false, isTraitement=true, isAnamnese=false, isXclinique = false, isXcomplement = false, isDiag = false, isCat = false, isCompterendu = false, dropHidden=false">
                                    <p>Traitement actuel</p>
                                </div>
                                <div class="p-2" @click="mobileClinique()">
                                    <p>Examens clinique</p>
                                </div>
                                <div class="p-2" @click="mobileComplementaire()">
                                    <p>Examens Complèmentaires</p>
                                </div>
                                <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isParam=false, isTraitement=false, isAnamnese=false, isXclinique = false, isXcomplement = false, isDiag = true, isCat = false, isRdv = false, dropHidden=false">
                                    <p>Diagnostic</p>
                                </div>
                                <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isParam=false, isTraitement=false, isAnamnese=false, isXclinique = false, isXcomplement = false, isDiag = false, isCat = true, isRdv = false, dropHidden=false">
                                    <p>CAT</p>
                                </div>
                                <div class="p-2" @click="isInfo = true, isAllergie=false, isAntecedent=false, isParam=false, isTraitement=false, isAnamnese=false, isXclinique = false, isXcomplement = false, isDiag = false, isCat = false, isRdv = false, dropHidden=false">
                                    <p>Info supplémentaire</p>
                                </div>
                                <div class="p-2" @click="isInfo = false, isAllergie=false, isAntecedent=false, isParam=false, isTraitement=false, isAnamnese=false, isXclinique = false, isXcomplement = false, isDiag = false, isCat = false, isRdv = true, dropHidden=false">
                                    <p>RDV</p>
                                </div>
                            </div>
                        </div>    
                    </div>
                    <b-tabs content-class="pt-4" fill class="mobileConsult">
                        <b-tab :title="$t('message.settings')" v-if="isParam">
                            
                                <b-row class="w-100">
                                    <b-col sm="6">
                                        <b-form-group id="occupation-group" :label="$t('message.profession')" label-for="occupation-propose">
                                            <b-form-input id="occupation" v-model="$v.form.profession.$model" :state="$v.form.profession.$dirty ? !(errorshasField('profession') || $v.form.profession.$error) : null" @focus="clearErrorField('profession')"></b-form-input>

                                            <b-form-invalid-feedback v-if="errorshasField('profession')">
                                                {{ getErrorsField('profession') }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>

                                    <b-col sm="6">
                                        <b-form-group :label="$t('message.familyStuation')">
                                            <b-form-radio-group id="situation_familiale" v-model="$v.form.situation_familiale.$model" name="situation_familiale">
                                                <b-form-radio value="Marié(e)">{{$t('message.marie')}}</b-form-radio>
                                                <b-form-radio value="Celibataire">{{$t('message.celibataire')}}</b-form-radio>
                                            </b-form-radio-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4" sm="4">
                                        <b-col sm="2">
                                            <div>
                                                <label class="form__label" for="hasDesc">{{$t('message.tabac')}}</label>
                                                <div class="toggle">
                                                    <input id="hasDesc2" type="checkbox" v-model="smoke" />
                                                    <label for="hasDesc2">
                                                        <div class="toggle__switch"></div>
                                                    </label>
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col sm="5" v-if="smoke" :class="{ 'form-group--error': $v.form.tabac.$error}">
                                            <span class="obligatoire">*</span>

                                            <b-form-group id="email-group" :label="$t('message.smokedPerDay')" label-for="tabac">
                                                <b-form-input id="tabac" v-model="$v.form.nbreParJour.$model" :state="$v.form.nbreParJour.$dirty ? !(errorshasField('tabac') || $v.form.nbreParJour.$error) : null" type="text" required placeholder="" @focus="clearErrorField('tabac')"></b-form-input>

                                                <b-form-invalid-feedback v-if="!$v.form.tabac.required">
                                                    {{ $t('message.requiredField') }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="5" v-if="smoke" :class="{ 'form-group--error': $v.form.tabac.$error}">
                                            <span class="obligatoire">*</span>
                                            <b-form-group id="tabac2-group" :label="$t('message.numberOfYear')" label-for="tabac2">
                                                <b-form-input id="tabac2" v-model="$v.form.nbreAnnee.$model" :state="$v.form.nbreAnnee.$dirty ? !(errorshasField('tabac') || $v.form.nbreAnnee.$error) : null" type="text" required placeholder="" @focus="clearErrorField('tabac')"></b-form-input>

                                                <b-form-invalid-feedback v-if="!$v.form.nbreAnnee.required">
                                                    {{ $t('message.requiredField') }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </b-col>
                                    </b-col>
                                    <b-col cols="4" sm="4">
                                        <b-col sm="2">
                                            <div>
                                                <label class="form__label" for="hasDesc">{{$t('message.alcool')}}</label>
                                                <div class="toggle">
                                                    <input id="hasDesc3" type="checkbox" v-model="drink" />
                                                    <label for="hasDesc3">
                                                        <div class="toggle__switch"></div>
                                                    </label>
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col sm="5">
                                            <div v-if="drink" :class="{ 'form-group--error': $v.form.alcool.$error}">
                                                <span class="obligatoire">*</span>

                                                <b-form-group id="email-group" :label="$t('message.value')" label-for="alcool">
                                                    <b-form-input id="alcool" v-model="$v.form.alcool.$model" :state="$v.form.alcool.$dirty ? !(errorshasField('alcool') || $v.form.alcool.$error) : null" type="text" required placeholder="" @focus="clearErrorField('alcool')"></b-form-input>

                                                    <b-form-invalid-feedback v-if="!$v.form.alcool.required">
                                                        {{ $t('message.requiredField') }}
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                    </b-col>
                                    <b-col cols="4" sm="4">
                                        <b-col sm="2">
                                            <div>
                                                <label class="form__label" for="hasDesc">{{$tc('message.enfants',1)}}</label>
                                                <div class="toggle">
                                                    <input id="hasDesc" type="checkbox" v-model="hasChild" />
                                                    <label for="hasDesc">
                                                        <div class="toggle__switch"></div>
                                                    </label>
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col sm="5">
                                            <div v-if="hasChild" :class="{ 'form-group--error': $v.form.nbre_enfant.$error}">
                                                <span class="obligatoire">*</span>

                                                <b-form-group id="email-group" :label="$t('message.nombreEnfant')" label-for="email">
                                                    <b-form-input id="email" v-model="$v.form.nbre_enfant.$model" :state="$v.form.nbre_enfant.$dirty ? !(errorshasField('nbre_enfant') || $v.form.nbre_enfant.$error) : null" type="text" required placeholder="" @focus="clearErrorField('nbre_enfant')"></b-form-input>

                                                    <b-form-invalid-feedback v-if="!$v.form.nbre_enfant.required">
                                                        {{ $t('message.requiredField') }}
                                                    </b-form-invalid-feedback>

                                                    <b-form-invalid-feedback v-else-if="!$v.form.nbre_enfant.email">
                                                        {{ $t('message.emailNotValid') }}
                                                    </b-form-invalid-feedback>

                                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                                        {{ getErrorsField('email') }}
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col sm="12">
                                        <b-form-group id="autres-group" :label="$t('message.autres')" label-for="autres">
                                            <editor :api-key="tinyKey" id="autres" v-model="$v.form.autres.$model" :state="$v.form.autres.$dirty ? !(errorshasField('autres') || $v.form.autres.$error) : null" @focus="clearErrorField('autres')" :init="{
                                        height: 200,
                                        menubar: false,
                                        plugins: plugins,
                                        toolbar:toolbar
                                        }">
                                            </editor>

                                            <b-form-invalid-feedback v-if="errorshasField('autres')">
                                                {{ getErrorsField('autres') }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            
                            <h3 class="ml-2"> {{ $t('message.anthropometrie') }}</h3>

                            <b-row>

                                <b-col sm="6">

                                    <b-form-group id="poids-group" :label="$t('message.weight')" label-for="poids">
                                        <b-form-input id="reference" v-model="$v.form.poids.$model" :state="$v.form.poids.$dirty ? !(errorshasField('poids') || $v.form.poids.$error) : null" @focus="clearErrorField('poids')" type="number" step="0.01"></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.poids.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-if="errorshasField('poids')">
                                            {{ getErrorsField('poids') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="6">

                                    <b-form-group id="taille-group" :label="$t('message.height')" label-for="taille">
                                        <b-form-input id="taille" v-model="$v.form.taille.$model" :state="$v.form.taille.$dirty ? !(errorshasField('taille') || $v.form.taille.$error) : null" @focus="clearErrorField('taille')" type="number" step="0.01"></b-form-input>
                                        <b-form-invalid-feedback v-if="!$v.form.taille.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('taille')">
                                            {{ getErrorsField('taille') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="6">

                                    <b-form-group id="circonferenceAbdominal-group" :label="$t('message.circonferenceAbdominal')" label-for="circonferenceAbdominal">
                                        <b-form-input id="reference" v-model="$v.form.circonferenceAbdominal.$model" :state="$v.form.circonferenceAbdominal.$dirty ? !(errorshasField('circonferenceAbdominal') || $v.form.circonferenceAbdominal.$error) : null" @focus="clearErrorField('circonferenceAbdominal')" type="number" step="0.01"></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.circonferenceAbdominal.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-if="errorshasField('circonferenceAbdominal')">
                                            {{ getErrorsField('circonferenceAbdominal') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="6">

                                    <b-form-group id="circonferenceCranienne-group" :label="$t('message.circonferenceCranienne')" label-for="circonferenceCranienne">
                                        <b-form-input id="circonferenceCranienne" v-model="$v.form.circonferenceCranienne.$model" :state="$v.form.circonferenceCranienne.$dirty ? !(errorshasField('circonferenceCranienne') || $v.form.circonferenceCranienne.$error) : null" @focus="clearErrorField('circonferenceCranienne')" type="number" step="0.01"></b-form-input>
                                        <b-form-invalid-feedback v-if="!$v.form.circonferenceCranienne.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('circonferenceCranienne')">
                                            {{ getErrorsField('circonferenceCranienne') }} 
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
<!--                                         <b-col sm="6">
                                    <b-form-group id="bmi-group" :label="$t('message.bmi')" label-for="bmi">
                                        <b-form-input id="bmi"  :state="$v.form.bmi.$dirty ? !(errorshasField('bmi') || $v.form.bmi.$error) : null" @focus="clearErrorField('bmi')" type="number" step="0.01" disabled="disabled"></b-form-input>
                                        <b-form-invalid-feedback v-if="!$v.form.bmi.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('bmi')">
                                            {{ getErrorsField('bmi') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col> -->
                            </b-row>                                    
                            <h3 class="ml-2"> {{ $t('message.signevitaux') }}</h3>
                            <b-row>

                                <b-col sm="6">

                                    <b-form-group id="ta_systolique-group" :label="$t('message.taSystolique')" label-for="ta_systolique">
                                        <b-form-input id="ta_systolique" v-model="$v.form.ta_systolique.$model" :state="$v.form.ta_systolique.$dirty ? !(errorshasField('ta_systolique') || $v.form.ta_systolique.$error) : null" @focus="clearErrorField('ta_systolique')" type="number" step="0.01"></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.ta_systolique.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('ta_systolique')">
                                            {{ getErrorsField('ta_systolique') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col sm="6">

                                    <b-form-group id="ta_diastolique-group" :label="$t('message.taDiastolique')" label-for="ta_diastolique">
                                        <b-form-input id="ta_diastolique" v-model="$v.form.ta_diastolique.$model" :state="$v.form.ta_diastolique.$dirty ? !(errorshasField('ta_diastolique') || $v.form.ta_diastolique.$error) : null" @focus="clearErrorField('ta_diastolique')" type="number" step="0.01"></b-form-input>
                                        <b-form-invalid-feedback v-if="!$v.form.ta_diastolique.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('ta_diastolique')">
                                            {{ getErrorsField('ta_diastolique') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">

                                    <b-form-group id="frequence_cardiaque-group" :label="$t('message.heartRate')" label-for="frequence_cardiaque">
                                        <b-form-input id="frequence_cardiaque" v-model="$v.form.frequence_cardiaque.$model" :state="$v.form.frequence_cardiaque.$dirty ? !(errorshasField('frequence_cardiaque') || $v.form.frequence_cardiaque.$error) : null" @focus="clearErrorField('frequence_cardiaque')" type="number" step="0.01"></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.frequence_cardiaque.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('frequence_cardiaque')">
                                            {{ getErrorsField('frequence_cardiaque') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                </b-col>

                                <b-col sm="6">

                                    <b-form-group id="frequence_respiratoire-group" :label="$t('message.respiratoryRate')" label-for="frequence_respiratoire">
                                        <b-form-input id="frequence_respiratoire" v-model="$v.form.frequence_respiratoire.$model" :state="$v.form.frequence_respiratoire.$dirty ? !(errorshasField('frequence_respiratoire') || $v.form.frequence_respiratoire.$error) : null" @focus="clearErrorField('frequence_respiratoire')" type="number" step="0.01"></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.frequence_respiratoire.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('frequence_respiratoire')">
                                            {{ getErrorsField('frequence_respiratoire') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                </b-col>
                                <b-col sm="6">

                                    <b-form-group id="temperature-group" :label="$t('message.temperature')" label-for="temperature">
                                        <b-form-input id="temperature" v-model="$v.form.temperature.$model" :state="$v.form.temperature.$dirty ? !(errorshasField('temperature') || $v.form.temperature.$error) : null" @focus="clearErrorField('temperature')" type="number" step="0.01"></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.temperature.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('temperature')">
                                            {{ getErrorsField('temperature') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>

                                </b-col>
                                <b-col sm="6">

                                    <b-form-group id="sato2-group" :label="$t('message.sato2')" label-for="sato2">
                                        <b-form-input id="sato2" v-model="$v.form.sato2.$model" :state="$v.form.sato2.$dirty ? !(errorshasField('sato2') || $v.form.sato2.$error) : null" @focus="clearErrorField('sato2')" type="number" step="0.01"></b-form-input>
                                        <b-form-invalid-feedback v-if="!$v.form.sato2.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('sato2')">
                                            {{ getErrorsField('sato2') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <h3 class="ml-2">{{ $t('message.nutrition') }}</h3>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group>
                                        <b-form-checkbox  v-model="$v.form.malnutrition.$model" >{{ $t('message.malnutrition') }}</b-form-checkbox>
                                        <b-form-checkbox  v-model="$v.form.deshydratation.$model">{{ $t('message.deshydradation') }}</b-form-checkbox>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <h3 class="ml-2">{{ $t('message.glucose') }}</h3>
                            <b-row>
                                <b-col sm="6">

                                    <b-form-group id="glycemie-group" :label="$t('message.glycemie')" label-for="glycemie">
                                        <b-form-input id="glycemie" v-model="$v.form.glycemie.$model" :state="$v.form.glycemie.$dirty ? !(errorshasField('glycemie') || $v.form.glycemie.$error) : null" @focus="clearErrorField('glycemie')" type="number" step="0.01"></b-form-input>
                                        <b-form-invalid-feedback v-if="!$v.form.glycemie.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('glycemie')">
                                            {{ getErrorsField('glycemie') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group id="glycated-group" :label="$t('message.glycated')" label-for="glycated">
                                        <b-form-input id="glycated" v-model="$v.form.glycated.$model" :state="$v.form.glycated.$dirty ? !(errorshasField('glycated') || $v.form.glycated.$error) : null" @focus="clearErrorField('glycated')" type="number" step="0.01"></b-form-input>
                                        <b-form-invalid-feedback v-if="!$v.form.glycated.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('glycated')">
                                            {{ getErrorsField('glycated') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <h3 class="ml-2">{{ $t('message.lipide') }}</h3>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group id="cholestorol-group" :label="$t('message.cholestorol')" label-for="cholestorol">
                                        <b-form-input id="cholestorol" v-model="$v.form.cholestorol.$model" type="number" step="0.01"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="ldl-group" :label="$t('message.ldl')" label-for="ldl">
                                        <b-form-input id="ldl" v-model="$v.form.ldl.$model" type="number" step="0.01"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group id="hdl-group" :label="$t('message.hdl')" label-for="hdl">
                                        <b-form-input id="hdl" v-model="$v.form.hdl.$model" type="number" step="0.01"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="tags-group" :label="$t('message.tags')" label-for="tags">
                                        <b-form-input id="tags" v-model="$v.form.tags.$model" type="number" step="0.01"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab :title="$t('message.infoAntecedents')" v-if="isAntecedent">
                            <div id="antecedentForm">
                                <b-card-body v-if="antecedentsRows.length>0">
                                    <vue-good-table id="antecedent" v-if="notEmpty(antecedentsRows)" :columns="antecedentsColumns" :rows="antecedentsRows" :search-options="enabled" :pagination-options="paginationOptions" :groupOptions="enabled" :sort-options="sort" @on-row-click="onAntecedentRowClick" />
                                </b-card-body>
                                <div class="shadow">
                                    <div class="container-perso p-0" id="formAntecedent">
                                        <b-form @reset="onReset" v-if="show">
                                            <b-container class="p-0">
                                                <b-row class="p-0">
                                                    <b-col sm="12">
                                                        <span class="obligatoire">*</span>

                                                        <b-form-group id="type-group" :label="$t('message.select')+' '+$tc('message.types',1)" label-for="type" class="mt-2">
                                                            <!-- Options -->
                                                            <select id="type" v-model="$v.antecedents.type.$model" class="form-control is-invalid retirerBordure" required :state="$v.antecedents.type.$dirty ? !(errorshasField('type') || $v.antecedents.type.$error) : null" @focus="clearErrorField('type')">
                                                                <option v-for="item in types" :value="item.value" :key="item.value">
                                                                    {{ item.text }}
                                                                </option>
                                                            </select>

                                                            <b-form-invalid-feedback v-if="$v.antecedents.type.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>

                                                            <b-form-invalid-feedback v-else-if="errorshasField('type')">
                                                                {{ getErrorsField('type') }}
                                                            </b-form-invalid-feedback>

                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col sm="12">

                                                        <b-form-group id="date-group" :label="$t('message.startDate')" label-for="date">
                                                            <b-form-input id="date" v-model="$v.antecedents.date.$model" :state="$v.antecedents.date.$dirty ? !(errorshasField('date') || $v.allergiesForm.date.$error) : null" type="date" required @click="clearErrorField('date')"></b-form-input>

                                                            <b-form-invalid-feedback v-if="$v.antecedents.date.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>
                                                            <span v-if="errorshasField('date')" style="color:red">
                                                                {{getErrorsField('date')}}
                                                            </span>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col sm="12">
                                                        <span class="obligatoire">*</span>

                                                        <b-form-group id="description-group" :label="$t('message.description')" label-for="description">
                                                            <b-form-textarea id="description" v-model="$v.antecedents.description.$model" :state="$v.antecedents.description.$dirty ? !(errorshasField('description') || $v.antecedents.description.$error) : null" required @focus="errorshasField('description')"></b-form-textarea>
                                                            <b-form-invalid-feedback v-if="!$v.antecedents.description.required">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>
                                                            <b-form-invalid-feedback v-if="!$v.antecedents.description.minLength">
                                                                {{ $t('message.minCharacters', { n: 3 }) }}
                                                            </b-form-invalid-feedback>
                                                            <b-form-invalid-feedback v-if="errorshasField('description')">
                                                                {{ getErrorsField('description') }}
                                                            </b-form-invalid-feedback>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col sm="1">
                                                    </b-col>
                                                </b-row>
                                                <b-row v-if="can">
                                                    <div class="text-center col-md-12 mb-3">
                                                        <b-button @click="onAntecedentSubmit" variant="primary">
                                                            {{ $t('message.save') }}
                                                        </b-button>
                                                    </div>
                                                    
                                                    <!--                                                <a href="#retourConsultation" class="pt-2"> <i class="fas fa-angle-double-up"></i>  {{$t('message.back')}}</a>-->

                                                </b-row>
                                            </b-container>
                                        </b-form>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab :title="$t('message.infoAllergies')" v-if="isAllergie">
                            <div id="allergieForm">
                                <b-card-body v-if=" allergiesRows.length>0">
                                    <vue-good-table id="allergie" v-if="notEmpty(allergiesRows)" :columns="allergiesColumns" :rows="allergiesRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onAllergieRowClick" />
                                </b-card-body>
                                <div class="shadow">
                                    <div class="container-perso" id="formAllergie">
                                        <b-form @reset="onReset" v-if="show">
                                            <b-container>
                                                <b-row>
                                                    <b-col sm="12">
                                                        <span class="obligatoire">*</span>

                                                        <b-form-group id="type-group" :label="$t('message.add')+' '+$tc('message.description',1)" label-for="type" class="mt-2">
                                                            <!-- Options -->
                                                            <select id="allergies" v-model="$v.allergiesForm.description.$model" required class="form-control is-invalid retirerBordure" :state="$v.allergiesForm.description.$dirty ? !(errorshasField('type') || $v.allergiesForm.description.$error) : null" @focus="clearErrorField('type')" multiple>
                                                                <option data-placeholder="true"></option>
                                                                <option v-for="item in descriptions" :value="item.value" :key="item.value">
                                                                    {{ item.text }}
                                                                </option>
                                                            </select>

                                                            <b-form-invalid-feedback v-if="$v.allergiesForm.description.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>

                                                            <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                                                {{ getErrorsField('description') }}
                                                            </b-form-invalid-feedback>

                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row v-if="can">
                                                    <div class="text-center col-md-12 mb-3">
                                                        <b-button @click="onAllergieSubmit" variant="primary">
                                                        {{ $t('message.saveAllergie') }}
                                                    </b-button>
                                                    </div>
                                                    
                                                </b-row>
                                            </b-container>
                                        </b-form>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab :title="$t('message.currentTreatments')" v-if="isTraitement">    
                            <b-row class="mobileEditor">
                                
                                    <editor :api-key="tinyKey" id="traitementsACreer" :label="$t('message.currentTreatments')" label-for="traitementsACreer" @focus="clearErrorField('anamese')" v-model="$v.form.traitements.$model" :state="$v.form.traitements.$dirty ?  !(errorshasField('traitements') || $v.form.traitements.$error) : null" :init="{
                                                    height: 200,
                                                    menubar: false,
                                                    plugins: plugins,
                                                    toolbar:toolbar
                                                    }">
                                    </editor>
                                
                            </b-row>
                        </b-tab>
                        <b-tab :title="$t('message.anamnesis')" v-if="isAnamnese">
                            <b-row>
                                <div v-for="(c,key) in anamneses" :key="key">
                                    <b-form-group :label="key" v-slot="{ ariaDescribedby }">
                                        <b-form-checkbox-group name="anamneses" v-model="anamneseChecked" text-field="fr_description" :aria-describedby="ariaDescribedby" stacked>
                                            <b-form-checkbox v-for="(item, index) in c" :value="item" :key="index" switch>
                                                <span>{{item.fr_description}}</span>
                                            </b-form-checkbox>
                                        </b-form-checkbox-group>
                                    </b-form-group>

                                </div>
                            </b-row>
                            <b-row class="mobileEditor">
                            <b-col sm="12">
                                <b-form-group
                                    id="anamese-group"
                                    :label="$t('message.anamnesis')"
                                    label-for="anamese"
                                    >
                                    <editor
                                        :api-key="tinyKey"
                                        initialValue=""
                                        v-model="$v.form.anamese.$model"
                                        :state="
                                        $v.form.anamese.$dirty
                                            ? !(
                                                errorshasField('anamese') ||
                                                $v.form.anamese.$error
                                            )
                                            : null
                                        "
                                        @focus="clearErrorField('anamese')"
                                        :init="{
                                        height: 200,
                                        menubar: false,
                                        plugins: plugins,
                                        toolbar: toolbar,
                                        }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback
                                        v-if="errorshasField('anamese')"
                                    >
                                        {{ getErrorsField("anamese") }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab :title="$t('message.examenclinique')" v-if="isXclinique">
                            <b-row class="ml-4">
                                <div v-for="(c,key) in examens" :key="key">
                                    <b-form-group :label="key" v-slot="{ ariaDescribedby }">
                                        <b-form-checkbox-group name="examens" v-model="examenChecked" text-field="fr_description" :aria-describedby="ariaDescribedby" stacked switch>
                                            <b-form-checkbox v-for="(item, index) in c" :value="item" :key="index">
                                                <span>{{item.fr_description}}</span>
                                            </b-form-checkbox>
                                        </b-form-checkbox-group>
                                    </b-form-group>
                                </div>
                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group
                                    id="clinique-group"
                                    :label="$tc('message.physicalExams', 2)"
                                    label-for="clinique"
                                    >
                                    <editor
                                        :api-key="tinyKey"
                                        initialValue=""
                                        v-model="$v.form.examen_clinique.$model"
                                        :state="
                                        $v.form.examen_clinique.$dirty
                                            ? !(
                                                errorshasField('examen_clinique') ||
                                                $v.form.examen_clinique.$error
                                            )
                                            : null
                                        "
                                        @focus="clearErrorField('examen_clinique')"
                                        :init="{
                                        height: 200,
                                        menubar: false,
                                        plugins: plugins,
                                        toolbar: toolbar,
                                        }"
                                    >
                                    </editor>
                                    <!--                                    <b-form-textarea-->
                                    <!--                                            id="clinique"-->
                                    <!--                                            v-model="$v.form.examen_clinique.$model"-->
                                    <!--                                            :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"-->
                                    <!--                                            rows="5"-->
                                    <!--                                            @focus="clearErrorField('examen_clinique')"-->
                                    <!--                                    ></b-form-textarea>-->

                                    <b-form-invalid-feedback
                                        v-if="errorshasField('examen_clinique')"
                                    >
                                        {{ getErrorsField("examen_clinique") }}
                                    </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                      
                        <b-tab :title="$t('message.examencomplementaire')" v-if="isXcomplement">

                                <b-row class="ml-3">
                                    <div v-for="(c,key) in complementaires" :key="key">
                                        <b-form-group :label="key" v-slot="{ ariaDescribedby }">
                                            <div class="container">
                                                <div class="d-flex">
                                                    <div class="overflow-auto p-2 mr-3" style=" max-height: 400px;">
                                                        <b-form-checkbox-group name="complementaires" v-model="complementaireChecked" text-field="fr_description" :aria-describedby="ariaDescribedby"  switch>
                                                            <b-form-checkbox v-for="(item, index) in c" :value="item" :key="index">
                                                                <span>{{item.fr_description}}</span>
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </div>
                                                </div>
                                            </div>
                                    </b-form-group>
                                </div>
                            </b-row>
                            <b-row class="mobileEditor">
                                <b-col sm="12">
                                    <b-form-group
                                    id="complementaire-group"
                                    :label="$t('message.examencomplementaire')"
                                    label-for="complementaire"
                                    >
                                    <editor
                                        :api-key="tinyKey"
                                        initialValue=""
                                        v-model="$v.form.complementaire.$model"
                                        :state="
                                        $v.form.complementaire.$dirty
                                            ? !(
                                                errorshasField('complementaire') ||
                                                $v.form.complementaire.$error
                                            )
                                            : null
                                        "
                                        @focus="clearErrorField('complementaire')"
                                        :init="{
                                        height: 200,
                                        menubar: false,
                                        plugins: plugins,
                                        toolbar: toolbar,
                                        }"
                                    >
                                    </editor>

                                    <b-form-invalid-feedback
                                        v-if="errorshasField('complementaire')"
                                    >
                                        {{ getErrorsField("complementaire") }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab :title="$t('message.diagnostic')" v-if="isDiag">

                            <b-row class="row ">
                                <span class="obligatoire">*</span>
                                <b-col cols="8">
                                    <div class="icd-instance">
                                    <div class="icd">
                                        <!-- <div class="icd-search"> -->
                                        <b-form-input type="text" placeholder="Tapez votre recherche en Anglais" class="ctw-input" id="ctw-input" autocomplete="off" data-ctw-ino="1" v-model="$v.form.diagnostic.$model" @change="clearErrorField('diagnostic')" required>

                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="!$v.form.diagnostic.required">
                                            {{ $t('message.diagnostic') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('diagnostic')">
                                            {{ getErrorsField('diagnostic') }}
                                        </b-form-invalid-feedback>
                                            <!-- <button class="icd-clear" :click="clear" title="Clear search and results">❌</button> -->
                                        <!-- </div>   -->
                                    </div>
                                        Votre sélection est: <span id="icd-paste-selected-1"></span>
                                    <div class="ctw-window" data-ctw-ino="1"></div>
                                    </div>

                                        <b-form-invalid-feedback
                                            v-if="errorshasField('complementaire')"
                                        >
                                            {{ getErrorsField("complementaire") }}
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab :title="$t('message.cat')" v-if="isCat">
                                <b-col sm="12" class="mobileEditor">
                                    <b-form-group id="traitement-propose-group" :label="$t('message.cat')" label-for="traitement-propose">
                                        <editor :api-key="tinyKey" id="traitement_propose" v-model="$v.form.traitement_propose.$model" :state="$v.form.traitement_propose.$dirty ? !(errorshasField('traitement_propose') || $v.form.traitement_propose.$error) : null" @focus="clearErrorField('traitement_propose')" :init="{
                                                    height: 200,
                                                    menubar: false, 
                                                    plugins: plugins,
                                                    toolbar:toolbar
                                                    }">
                                        </editor>
                                        <b-form-invalid-feedback v-if="errorshasField('traitement_propose')">
                                            {{ getErrorsField('traitement_propose') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    
                                    <div class="text-right appointment-item" >
                                        <div id="icd-selected-1">
                                            <table class="table .table-responsive" >
                                                    <thead>
                                                        <tr>
                                                        <th scope="col">ICD code</th>
                                                        <th scope="col">name</th>
                                                        <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(item,key) in slectedIcd" :key="key" class="mt-2">
                                                        <td>{{item.code}}</td>
                                                        <td> <p  style="">{{item.bestMatchText}}</p></td>
                                                        <td>
                                                            <b-button pill variant="danger" @click="remove(item.code)" size="sm">x</b-button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </b-col> 
                                
                            </b-tab>
                        <!-- <b-tab :title="$t('message.cat')" v-if="isCat">
                            <b-col sm="12" class="mobileEditor">
                                <b-form-group id="traitement-propose-group" :label="$t('message.cat')" label-for="traitement-propose">
                                    <editor :api-key="tinyKey" id="traitement_propose" v-model="$v.form.traitement_propose.$model" :state="$v.form.traitement_propose.$dirty ? !(errorshasField('traitement_propose') || $v.form.traitement_propose.$error) : null" @focus="clearErrorField('traitement_propose')" :init="{
                                                height: 200,
                                                menubar: false, 
                                                plugins: plugins,
                                                toolbar:toolbar
                                                }">
                                    </editor>
                                    <b-form-invalid-feedback v-if="errorshasField('traitement_propose')">
                                        {{ getErrorsField('traitement_propose') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-tab> -->
                        <b-tab :title="$t('message.infosupplementaire')" v-if="isInfo">
                            <b-col sm="12">
                                <b-form-group id="infor-mation-group" :label="$t('message.infosupplementaire')" label-for="infor-mation">
                                    <editor :api-key="tinyKey" id="information" v-model="$v.form.information.$model" :state="$v.form.information.$dirty ? !(errorshasField('information') || $v.form.information.$error) : null" @focus="clearErrorField('information')" :init="{
                                                height: 200,
                                                menubar: false,
                                                plugins: plugins,
                                                toolbar:toolbar
                                                }">
                                    </editor>
                                    <b-form-invalid-feedback v-if="errorshasField('information')">
                                        {{ getErrorsField('information') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-row>
                                <b-col sm="8">
                                    <b-form-group id="upload-group" :label="$t('message.uploadFile')" label-for="upload">
                                        <b-form-file multiple type="file" accept=".jpeg, .png, .gif, .pdf, .docx" ref="file_input" id="upload" :state="$v.form.documents.$dirty ? !$v.form.documents.$error : null" :placeholder="$t('message.uploadFile')">
                                            <template slot="file-name" slot-scope="{ names }">
                                                <b-badge variant="dark">{{ names[0] }}</b-badge>
                                                <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                                                    + {{ names.length - 1 }} More documents
                                                </b-badge>
                                            </template>
                                        </b-form-file>
                                        <span style="color: red" v-if="errorshasField('documents')">
                                            {{ getErrorsField('documents') }}
                                        </span>

                                        <span style="color: red" v-if="maxFileSize.length>0">{{ maxFileSize }}</span>

                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group id="u" label="." label-for="upload">
                                        <b-button @click="cleardocuments">{{ $t('message.emptyUpload') }}</b-button>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            

                        </b-tab>
                        <b-tab :title="$t('message.rdv')" v-if="isRdv">
                                <b-col sm="12">
                                <b-form-group id="date_rdv" :label="$t('message.appointmentDate')" label-for="appointmentDate">
                                    <vue-ctk-date-time-picker class="border-dark" v-model="$v.form.dateRdv.$model"></vue-ctk-date-time-picker>
                                </b-form-group>
                                
                            </b-col>
                            <b-col sm="12">
                                <b-form-group id="traitement-appointmentReason-group" :label="$t('message.appointmentReason')" label-for="appointmentReason">
                                    <editor :api-key="tinyKey" id="appointmentReason" v-model="$v.form.motifRdv.$model" :init="{
                                                height: 200,
                                                menubar: false,
                                                plugins: plugins,
                                                toolbar:toolbar
                                                }">
                                    </editor>
                                </b-form-group>
                            </b-col>
                            <b-row>
                                <b-col md="6" sm="12">
                                    <b-form-group id="isConsultantDoctor-group" :label="$t('message.isConsultantDoctor')" label-for="isConsultantDoctor">
                                        <b-form-radio v-model="$v.form.isConsultantDoctor.$model" name="isConsultantDoctor" value="true" :inline="true">
                                            {{ $t('message.yes') }}
                                        </b-form-radio>
                                        <b-form-radio v-model="$v.form.isConsultantDoctor.$model" name="isConsultantDoctor" value="false" :inline="true">
                                            {{ $t('message.no') }}
                                        </b-form-radio>
                                        <b-form-invalid-feedback v-if="errorshasField('isConsultantDoctor')">
                                            {{ getErrorsField('isConsultantDoctor') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-if="$v.form.isConsultantDoctor.$error">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>

                                </b-col>
                            </b-row>
                            <b-row v-if="form.isConsultantDoctor === 'false'" class="mt-3">
                                <b-col md="6" sm="12">
                                    <b-form-group id="consultantDoctor-group" :label="$t('message.select')+' '+$tc('message.medecin',1)" label-for="patient">

                                        <b-form-radio v-model="$v.form.medecinSource.$model" name="medecinSource" value="fromMedicasure" :inline="true">
                                            {{ $t('message.fromMedicasure') }}
                                        </b-form-radio>
                                        <b-form-radio v-model="$v.form.medecinSource.$model" name="medecinSource" value="fromOthers" :inline="true">
                                            {{ $t('message.fromOthers') }}
                                        </b-form-radio>
                                        <!-- Options -->
                                        <multiselect v-if="form.medecinSource === 'fromMedicasure'" v-model="$v.form.practicien_id.$model" :options="mContributors" :multiple="true" :placeholder="$t('message.fromOthers')" selectLabel="Sélectionner" label="nom" track-by="id"></multiselect>
                                        <!-- <select v-if="form.medecinSource === 'fromMedicasure'" id="consultantDoctor" v-model="$v.form.practicien_id.$model" class="form-control is-invalid border-light mt-2">
                                            <option v-for="item in mContributors" :value="item.id" :key="item.id">
                                                {{ item.nom }}
                                            </option>
                                        </select> -->

                                        <b-form-input id="doctorName" class="mt-2" v-else v-model="$v.form.doctorName.$model" :placeholder="$t('message.preciseDoctorName')"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>

                    </b-tabs>
                </b-row>
                
                <b-row class="justify-content-sm-center mb-3">
                    <b-button @click="onSubmit" variant="primary" v-if="can">
                        {{ $t('message.save') }}
                    </b-button>
                </b-row>
            </b-form>

        </b-container>
    </div>
</div>
</template>
<!-- <script src="https://unpkg.com/vue-multiselect@2.1.0"></script> -->

<script>

import {
    mapGetters
} from 'vuex';
import {
    required,
    minLength
} from 'vuelidate/lib/validators';
import _ from 'lodash';
import moment from 'moment';
import $ from 'jquery';
import Editor from '@tinymce/tinymce-vue';
import AppConfig from "../../../constants/AppConfig";
import {
    pagination,
    handlePaginationClick
} from "../../../helpers/paginations";
import * as ECT from '@whoicd/icd11ect';
import '@whoicd/icd11ect/style.css';
import loading from 'vue-loading-overlay';
import Multiselect from 'vue-multiselect'
export default {
    name: "NewEditGeneralMedicine",

    components: {
        editor: Editor,
        loading,
        Multiselect
    },

    computed: {
        ...mapGetters([
          "practitioners",
          "controlDoctors",
          "generalConsultation",
          "allergies",
          "reasons",
          "institutions",
          "userInstitutions",
          "errors",
          'hasAdminRole',
          'hasMedecinControleRole',
          'hasAssistante',
          'hasPraticienRole',
          'hasAssistante',
          'Timelines',
        ]),

        mMedicalFile: function () {
            return (_.isUndefined(this.file) || _.isNull(this.file)) ? [] : this.file;
        },

        mInstitutions: function () {
            let iArray = [];

            _.forEach(_.orderBy(this.userInstitutions, ['created_at'], ['desc']), function (institution) {
                let i = {};

                i.nom = institution.name;
                i.description = (!_.isNull(institution.description) ? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                i.date = moment(institution.created_at).format('DD-MM-YYYY');
                i.id = institution.id;
                i.slug = institution.slug;

                iArray.push(i);
            });

            return iArray;
        },
         
        lignetempsRows: function () {
            let self = this;
            let mArray = [];
            _.forEach(_.orderBy(self.Timelines, ['created_at'], ['desc']), function (timelines) {
                let motifs = "";
                let ids = "";

                if (timelines.hasOwnProperty('motif')) {

                    motifs = timelines.motif.description;

                    if (motifs.length > 105) {
                        motifs = timelines.motif.description.substring(0, 105) + " ...";
                    }
                }
                mArray.push({
                    id: timelines.id,
                    date: timelines.date_consultation,
                    motif: motifs,
                    etat: timelines.etat == null ? true : false,
                });
            });
            let sArray = mArray;
            mArray = self.filterResult(sArray, mArray);
            return mArray;
        },

        mReasons: function () {
            return this.reasons.map(reason => ({
                id: reason.id,
                description: reason.description
            })).filter(reason => reason.description != "" || reason.description != '[object Object]');
        },

        descriptions: function () {
            let aArray = [];

            if (!_.isUndefined(this.allergies)) {
                _.forEach(this.allergies, function (allergy) {
                    aArray.push({
                        text: allergy.description,
                        value: allergy.id
                    })
                })
                return aArray;
            }
            return aArray;
        },

        can: function () {
            if (this.hasAdminRole) {
                return true;
            } else {
                return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
            }
        },

        today: function () {
            return moment((new Date())).format('YYYY-MM-DD');
        },

    mAntecedents:function () {
      let mArray = [];
      if (this.generalConsultation.hasOwnProperty('dossier')){
        if (!_.isUndefined(this.generalConsultation.dossier.antecedents)){
          if (!_.isNull(this.generalConsultation.dossier.antecedents)){
            mArray = this.generalConsultation.dossier.antecedents;
          }
        }
        let cMedecines = this.generalConsultation.dossier.consultations_medecine;

        let cCardiologies = this.generalConsultation.dossier.cardiologies;

        _.forEach(cCardiologies, function(cardiologie){
          if (!_.isNull(cardiologie.conclusion) && cardiologie.conclusion !=='null'){
            let c = {}
            c.type = 'Consultation';
            c.description = cardiologie.conclusion;
            c.date = moment(cardiologie.updated_at).format('YYYY-MM-DD');
            mArray.unshift(c);
          }
        });

        _.forEach(cMedecines, function (medecine){
          _.forEach(medecine.conclusions, function(conclusion){
            let m = {};
            m.type = 'Consultation';
            m.description = conclusion.description;
            m.date = moment(conclusion.updated_at).format('YYYY-MM-DD')
            mArray.unshift(m);
          })
        })

        mArray = _.orderBy(mArray,['date'],['asc']);

      }


      return mArray;
    },

    mAllergies:function(){
      if (this.generalConsultation.hasOwnProperty('dossier')){
        if (!_.isUndefined(this.generalConsultation.dossier.allergies)){
          if (!_.isNull(this.generalConsultation.dossier.allergies)){
            return this.generalConsultation.dossier.allergies;
          }
          return  [];
        }
        return  [];
      }
      return [];
    },

        allergiesRows: function () {
            let aArray = [];

            _.forEach(_.orderBy(this.mAllergies, ['created_at'], ['desc']), function (allergy) {
                aArray.push({
                    description: allergy.description,
                    slug: allergy.slug
                })
            })

            return aArray;
        },

        antecedentsRows: function () {

            return _.chain(_.orderBy(this.mAntecedents, ['created_at'], ['desc']))
                .groupBy("type")
                .map((value, key) => ({
                    mode: "span",
                    label: key,
                    html: false,
                    children: value
                }))
                .value();

        },
        isDefine:function(){
          return (this.generalConsultation.file != 'null' && !_.isNull(this.generalConsultation.file)) || this.uploadFiles.length>0;
        },

        uploadFiles:function(){
          return _.isUndefined(this.generalConsultation.files) ? [] :this.generalConsultation.files;
        },
        mPractitioners: function () {
            let pArray = [];

            _.forEach(_.orderBy(this.practitioners, ['created_at'], ['desc']), function (practitioner) {
                let p = {};
                if ((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user))) {
                    let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
                    prenom = prenom.toLowerCase();
                    p.id = practitioner.user.id;
                    p.nom = (practitioner.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    if (p.nom.length > 0) {
                        pArray.push(p);
                    }
                }

            });

            return pArray;
        },

        mDoctors: function () {
            let dArray = [];

            _.forEach(_.orderBy(this.controlDoctors, ['created_at'], ['desc']), function (doctor) {
                let d = {};
                if ((typeof doctor.user == 'object') && (!_.isNull(doctor.user))) {
                    let prenom = doctor.user.prenom != null ? doctor.user.prenom : "";
                    prenom = prenom.toLowerCase();
                    d.id = doctor.user.id;
                    d.nom = (doctor.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);

                    if (d.nom.length > 0) {
                        dArray.push(d);
                    }
                }

            });

            return dArray;
        },

        mContributors: function () {
            let cArray = [];
            return cArray.concat(this.mDoctors, this.mPractitioners);
        },

        symtomeColunm: function () {
            return [{
                    label: this.$i18n.t('message.nom'),
                    field: 'nom',
                },
                {
                    label: this.$i18n.t('message.action'),
                    field: 'action',
                },
            ];
        },


      minDate:function(){
        return moment((this.form.date_consultation)).format('YYYY-MM-DD');
      },

      form: function() {
        let c ="";
        if (!_.isUndefined(this.generalConsultation.conclusions)){
          _.forEach(this.generalConsultation.conclusions, function (conclusion) {
            c +=  conclusion.description+" ";
          })

        }
        
        let consultation  = this.generalConsultation;
        let self = this;

        let glucydes = !_.isUndefined(self.generalConsultation.glucide) ? this.returnByType(self.generalConsultation.glucide) : null;
        let lipides = !_.isUndefined(self.generalConsultation.lipide) ? this.returnByType(self.generalConsultation.lipide) : null;
        let nutritions = !_.isUndefined(self.generalConsultation.nutrition) ? this.returnByType(self.generalConsultation.nutrition) : null;

        self.slectedIcd = !_.isUndefined(self.generalConsultation.diasgnostic) ? this.returnByType(self.generalConsultation.diasgnostic): null;
        self.complementaireChecked = !_.isUndefined(self.generalConsultation.examen_complementaire) ? this.returnByType(self.generalConsultation.examen_complementaire): null;
        self.examenChecked = !_.isUndefined(self.generalConsultation.examens) ? this.returnByType(self.generalConsultation.examens): null;
        self.anamneseChecked = !_.isUndefined(self.generalConsultation.anamneses) ? this.returnByType(self.generalConsultation.anamneses): null;
        consultation['poids'] = !_.isUndefined(self.generalConsultation.anthropometrie) ? this.returnByType(self.generalConsultation.anthropometrie).poids : null ;
        consultation['taille'] =  !_.isUndefined(self.generalConsultation.anthropometrie) ? this.returnByType(self.generalConsultation.anthropometrie).taille : null;
        consultation['circonferenceAbdominal'] = !_.isUndefined(self.generalConsultation.anthropometrie) ? this.returnByType(self.generalConsultation.anthropometrie).circonferenceAbdominal : null;
        consultation['circonferenceCranienne'] = !_.isUndefined(self.generalConsultation.anthropometrie) ? this.returnByType(self.generalConsultation.anthropometrie).circonferenceCranienne : null;
        // consultation['bmi'] = !_.isUndefined(self.generalConsultation.anthropometrie) ? this.returnByType(self.generalConsultation.anthropometrie).bmi : null;



        if(!_.isUndefined(self.generalConsultation.parametres_commun) && self.generalConsultation.parametres_commun.length >0 ) {
          consultation['ta_systolique'] = self.generalConsultation.parametres_commun[0].ta_systolique;
          consultation['ta_diastolique'] = self.generalConsultation.parametres_commun[0].ta_diastolique;
          consultation['frequence_cardiaque'] = self.generalConsultation.parametres_commun[0].frequence_cardiaque;
          consultation['frequence_respiratoire'] = self.generalConsultation.parametres_commun[0].frequence_respiratoire;
          consultation['temperature'] = self.generalConsultation.parametres_commun[0].temperature;
          consultation['sato2'] = self.generalConsultation.parametres_commun[0].sato2;
        }

        if(nutritions !== null){
          consultation['malnutrition'] = nutritions.malnutrition;
          consultation['deshydratation'] = nutritions.deshydratation;
        }

        if(glucydes !== null){
          consultation['glycemie'] = glucydes.glycemie;
          consultation['glycated'] = glucydes.glycated;
        }

        if(lipides !== null){
          consultation['cholestorol'] = lipides.cholestorol;
          consultation['ldl'] = lipides.ldl;
          consultation['hdl'] = lipides.hdl;
          consultation['tags'] = lipides.tags;
        }


        if (_.isNull(consultation.rdv) || _.isUndefined(consultation.rdv)){
          consultation.rdv = [];
          consultation.rdv['date']='';
          consultation.rdv['motifs']='';
          consultation.rdv['isConsultantDoctor'] = 'true';
          consultation.rdv['medecinSource'] = 'fromMedicasure';
          consultation.rdv['doctorName'] =  '';
          consultation.rdv['praticien_id'] = JSON.parse(localStorage.getItem('user'))['id'];

        }else{
          // Add additional data
          if (_.isNull(consultation.rdv.nom_medecin)) {
            let practicien = null;
            if (this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante){
              practicien = JSON.parse(localStorage.getItem('user'))['id'];
            }

            if (practicien == consultation.rdv.praticien_id) {
              consultation['isConsultantDoctor'] = 'true';
              consultation['praticien_id'] = practicien;
              consultation['medecinSource'] = 'fromMedicasure';
            } else {
              consultation['isConsultantDoctor'] = 'false';
              consultation['medecinSource'] = 'fromMedicasure';
              consultation['praticien_id'] = consultation.rdv.praticien_id;
            }
              consultation['dateRdv'] = consultation.rdv.date;
              consultation['motifRdv'] = consultation.rdv.motifs;
          } else {
            consultation['isConsultantDoctor'] = 'false';
            consultation['medecinSource'] = 'fromOthers';
            consultation['doctorName'] =  consultation.rdv.nom_medecin;
          }
        }
        consultation['conclusionEdit']= c ;

        consultation['contributors'] = consultation.contributors ;
         let motifselected = [];      
        if (!_.isUndefined(self.generalConsultation.motifs)){
            _.forEach(self.generalConsultation.motifs ,function (reason) {  
             let reasonId = reason.id;
                //  console.log(reason.description);
                motifselected.push(reasonId)
            })
        }
        consultation['motifs']= motifselected ;
        //console.log("consultation");
        //console.log(consultation);
        return consultation;
    },

    },

    data() {
        return {
            value: null,
            options: ['list', 'of', 'options'],
            icdField: [{key:'targetName',label:'ICD Name'},{key:'targetId',label:'ICD code'},{key:'action',label:'Select'}],
            isLoading: false,
            opacity: 0.5,
            canCancel: false,
            fullPage: true,
            mobileView: true,
            isParam: true,
            isAntecedent:false,
            isAllergie:false,  
            isTraitement:false,
            isAnamnese:false,
            isXcomplement:false,
            dropHidden:true,
            isXclinique:false,
            isDiag:false,
            isCat:false,
            isInfo:false,
            isRdv:false,
            nutrition: '',
            maxFileSize: '',
            terms: [],
            slectedIcd:[],
            checkedDiagnotics: [],
            tinyKey: AppConfig.tinyMceKey,
            anamneses: [],
            examens: [],
            current_motifs: [],
            contributors: [],
            complementaires: [],
            plugins: [
                'advlist autolink lists  image charmap',
                'searchreplace visualblocks code fullscreen',
                'print preview anchor insertdatetime media',
                'paste code help wordcount table'
            ],
            toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
            afficherAllergie: false,
            afficherAntecedent: false,
            file_id: this.$route.params.file,
            hasChild: false,
            smoke: false,
            drink: false,
            chosens: [],
            anamneseChecked: [],
            examenChecked: [],
            complementaireChecked: [],
            chosen: '',
            ligne_de_temps_id: {},
            rdv:{
              praticien_id:'',

              isConsultantDoctor: '',

              medecinSource: '',

              doctorName: '',
            },
            watch: {
                hasChild: function (oldValue, newValue) {
                    if (newValue == false) {
                        this.form.nbre_enfant = "0";
                    }
                },
                smoke: function (oldValue, newValue) {
                    if (newValue == false) {
                        this.form.tabac = 0;
                    }
                },
                drink: function (oldValue, newValue) {
                    if (newValue == false) {
                        this.form.alcool = "0";
                    }
                },
            },
            allergiesColumns: [{
                    label: 'Description',
                    field: 'description',
                },
                // {
                //     label: this.$i18n.t('message.startDate'),
                //     field: 'date',
                //     type: 'date',
                //     dateInputFormat: 'yyyy-MM-dd',
                //     dateOutputFormat: 'dd/MM/yyyy',
                // },
            ],

            antecedentsColumns: [{
                    label: this.$i18n.tc('message.types', 1),
                    field: 'type',

                },
                {
                    label: 'Description',
                    field: 'description',
                    html: true
                },
                {
                    label: this.$i18n.t('message.startDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],

            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [50, 50, 50]
            },
            filterCriteria: '',
            paginationObject: {},
            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            consultation_id: this.$route.params.consultation,
            antecedents: {
                type: '',
                description: '',
                date: this.today,
            },

            allergiesForm: {
                description: [],
                // date:''
            },

            show: true,
            types: [{
                    value: 'Médical',
                    text: 'Médical'
                },
                {
                    value: 'Chirugical',
                    text: 'Chirugical'
                },
                {
                    value: 'Gynéco-obstétrique',
                    text: 'Gynéco-obstétrique'
                },
                {
                    value: 'Familial',
                    text: 'Familial'
                }
            ],
        }
    },
    watch: {
        terms: function (newValue) {
            this.paginationObject = pagination(newValue);
        },

        filterCriteria: function (newValue) {
            this.handleFilter(newValue);
        }
    },
    methods: {
        hasHistory () { return window.history.length > 2 },
        nameLigne ({ date, motif }) {
            return `${motif} — ${date}`
        },
        handleView() {
       this.mobileView = window.innerWidth <= 990;
         },   
        dropDown() {
            var y = document.getElementById("myDIV")
            var x = document.getElementById("myDropdown");
            $('.mobileUl').click(function(){
            $('.mobileDropbtn').toggleClass("rotate");
            });
                if (x.style.display === "none") {
                    x.style.display = "block";       
                } else {
                    x.style.display = "none";
            }
        },
        remove:function(e) {

            this.slectedIcd = _.filter(this.slectedIcd, function (item) {
                return item.code != e;
            });
            // console.log(this.checkedDiagnotics)
        },
        clear(){
            alert()
            ECT.Handler.clear('1');
        },
        filterResult(sArray, mArray) {
            if (this.filteredValue == 1) {
                mArray = sArray;
            } else if (this.filteredValue == 2) {
                //Non archivés
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 3) {
                //Non transmis
                mArray = _.filter(mArray, function (medecine) {
                    return _.isNull(medecine.passedAt);
                })
            } else if (this.filteredValue == 4) {
                //Archivés
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.archievedAt);
                })
            } else if (this.filteredValue == 5) {
                //Transmis
                mArray = _.filter(mArray, function (medecine) {
                    return !_.isNull(medecine.passedAt);
                })
            }
            return mArray;
        },
        returnByType:function(data){
         if(typeof data === 'string'){
               return JSON.parse(data);
            }
            else if(typeof data === 'object'){
            return data;
           }else{
            return null;
          }
       },
       deleteReason() {
        let motifsAEnvoyer = [];
        _.forEach(this.$refs['my-table'].selectedRows ,function (motif) {
            motifsAEnvoyer.push(motif.motifId);
        })
        let self = this;

        let args = {
            consultation: self.generalConsultation.id,
            motifs: motifsAEnvoyer
        };
        let successMessage = this.$i18n.t('message.reasonDeleted');
        let errorMessages = {
            generic: this.$i18n.t('message.genericError'),
            error: this.$i18n.t('message.error')
        };

        this.$store.dispatch('deleteConsultationReason', { args, successMessage, errorMessages });
        },

        handleFilter(value) {
            if (value) {
                const newBills = this.terms.filter(app => {
                    let result = false;

                    if (app.id) {
                        result = result || app.id.toLowerCase().includes(value.toLowerCase());
                    }

                    if (app.name) {
                        result = result || app.name.toLowerCase().includes(value.toLowerCase());
                    }

                    return result;
                });

                this.paginationObject = pagination(newBills, 2);
            } else {
                this.paginationObject = pagination(this.terms, 2);
            }
        },
        _handlePaginationClick(action, evt) {
            evt.preventDefault();
            this.paginationObject = handlePaginationClick(action, {
                ...this.paginationObject
            });
        },
        getDoctors() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getControlDoctors', {
                args: args
            });
        },

        getPractitioners() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getPractitioners', {
                args: args
            });
        },

        cleardocuments() {
            this.$refs['file_input'].reset()
        },

        getUserInstitutions() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getUserInstitutions', {
                args: args
            });
        },

        pathTo(element) {
            if (this.$route.fullPath.includes('#')) {
                let position = this.$route.fullPath.search('#');
                return this.$route.fullPath.substr(0, position) + element;
            }
            return this.$route.fullPath + element;
        },

        toggleAntecedent() {
            this.afficherAntecedent = !this.afficherAntecedent;
        },

        toggleAllergie() {
            this.afficherAllergie = !this.afficherAllergie;
        },

        getInstitutions() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getInstitutions', {
                args: args
            });
        },

        getAllergies() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getAllergies', {
                args: args
            });
        },

        onAntecedentRowClick() {
            // this.$router.push({name: 'antecedent', params: {antecedent: params.row.slug, file: this.file_id}});
        },

        onAllergieRowClick(params) {
            this.$router.push({
                name: 'allergy',
                params: {
                    allergy: params.row.slug
                }
            });
        },

        notEmpty(item) {
            return item.length > 0;
        },

        getReasons() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getReasons', {
                args: args
            });
        },

        getMedicalFile() {
            let args = {
                file: this.file_id
            };

            this.$store.dispatch("getMedicalFile", {
                args
            });
        },
        getTimelines() {
            let args = {
                file: this.file_id != null ? this.file_id : localStorage.getItem('dossier_medical_slug'),
            };

            this.$store.dispatch("getTimelines", {
                args
            });
        },

        onSubmit: function (evt) {
            evt.preventDefault();

            this.$v.form.$touch();

            let files = this.$refs.file_input == undefined ? null : this.$refs.file_input.selectedFile ;
            let nomFichier = "";
            if (!_.isNull(files)) {
                _.forEach(files, function (file, key) {
                    let taille = (((file.size) / 1024) / 1024).toFixed(4);
                    if (taille > 5) {
                        nomFichier += key == 0 ? '' : ',' + file.name + ": " + taille + " Mo";
                    }
                });

                if (nomFichier.length > 0) {
                    this.maxFileSize = this.$i18n.t('message.maxFileSize') + nomFichier;
                } else {
                    this.maxFileSize = "";
                }
            }
            if (!_.isNull(this.form.dateRdv)) {
                this.form.dateRdv = moment(this.form.dateRdv).format('YYYY-MM-DD HH:mm');
            }
            if ( this.maxFileSize.length == 0) {
                let formData = new FormData();

                let praticien_id = '';
                if (this.form.isConsultantDoctor === 'true') {
                    if (this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante) {
                        praticien_id = JSON.parse(localStorage.getItem('user'))['id'];
                    }

                } else if (this.form.medecinSource === 'fromMedicasure') {
                    praticien_id = this.form.practicien_id;
                } else {
                    praticien_id = this.form.doctorName;
                }
                let glucide = JSON.stringify({
                    glycemie: this.form.glycemie,
                    glycated: this.form.glycated,
                });
                let lipide = JSON.stringify({
                    cholestorol: this.form.cholestorol,
                    hdl: this.form.hdl,
                    ldl: this.form.ldl,
                    tags: this.form.tags,
                });
                let nutrition = JSON.stringify({
                    malnutrition: this.form.malnutrition,
                    deshydratation: this.form.deshydratation,
                });
                let anthropometrie = JSON.stringify({
                    circonferenceCranienne: this.form.circonferenceCranienne,
                    circonferenceAbdominal: this.form.circonferenceAbdominal,
                    // bmi: this.form.bmi,
                    poids:this.form.poids,
                    taille:this.form.taille
                });
                this.form.tabac = (this.form.nbreCigarette / 20) * this.form.nbreAnnee;
                formData.append('dossier_medical_id', this.form.dossier_medical_id);
                formData.append('ligne_de_temps_id', this.form.ligne_de_temps_id.id);
                formData.append('nbreCigarette', this.form.nbreCigarette);
                formData.append('contributeurs', this.form.contributors.map(item => item.id));
                formData.append('nbreAnnee', this.form.nbreAnnee);
                formData.append('date_consultation', this.form.date_consultation);
                formData.append('mode_de_vie', _.isNull(this.form.mode_de_vie) ? '' : this.form.mode_de_vie);
                formData.append('anamese', _.isNull(this.form.anamese) ? '' : this.form.anamese);
                formData.append('examen_clinique', this.form.examen_clinique);
                formData.append('complementaire', this.form.complementaire);
                formData.append('traitement_propose', this.form.traitement_propose);
                formData.append('information', this.form.information);
                formData.append('motifs', this.form.current_motifs.map(item => item.id));
                formData.append('conclusions', this.form.conclusions);
                formData.append('profession', this.form.profession);
                formData.append('situation_familiale', this.form.situation_familiale);
                formData.append('nbre_enfant', this.form.nbre_enfant);
                formData.append('tabac', this.form.tabac);
                formData.append('alcool', this.form.alcool);
                formData.append('autres', this.form.autres);
                formData.append('etablissement_id', this.form.etablissement_id.id);
                //formData.append('poids', this.form.poids);
                //formData.append('taille', this.form.taille);
                formData.append('traitements', this.form.traitements);
                formData.append('dateRdv', this.form.dateRdv);
                formData.append('motifRdv', this.form.motifRdv);
                formData.append('praticien_id', '' + praticien_id);
                formData.append('glucide',  glucide);
                formData.append('lipide',  lipide);
                formData.append('nutrition',  nutrition);
                formData.append('diagnostic_complementaire',  this.form.diagnostic_complementaire);
                formData.append('diasgnostic', JSON.stringify(this.checkedDiagnotics));
                formData.append('examens', JSON.stringify(this.examenChecked));
                formData.append('examen_complementaire', JSON.stringify(this.complementaireChecked));
                formData.append('anamneses', JSON.stringify(this.anamneseChecked));
                formData.append('diasgnostic', JSON.stringify(this.slectedIcd));
                //formData.append('signe_vitaux', '' + signe_vitaux);anamneseChecked
                formData.append('anthropometrie', anthropometrie);
                // let self= this;
                if (!_.isNull(files) && (this.$refs.file_input.selectedFile != null)) {
                    for (var i = 0; i < this.$refs.file_input.selectedFile.length; i++) {
                        let file = this.$refs.file_input.selectedFile[i];
                        formData.append('documents[' + i + ']', file);
                    }
                }

                let successMessage = this.$i18n.t('message.generalConsultationCreated');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                // console.log(formData)
                this.$store.dispatch('updateGeneralConsultation', { args: formData, consultation: this.consultation_id, errorMessages, successMessage })
                    .then(() => {
                      // Scroll to the top of the page
                      document.body.scrollTop = 0; // For Safari
                      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                    });
            } else {
                // console.log(this.$v.form.$invalid)
                $('html, body').animate({
                    scrollTop: 0
                }, '300');
            }
        },

        onAllergieSubmit: function (evt) {
            evt.preventDefault();

            this.$v.allergiesForm.$touch();

            if (!this.$v.allergiesForm.$invalid) {
                let args = {
                    dossier_medical_id: this.generalConsultation.dossier.id,
                    description: this.allergiesForm.description.map(item => item.value),
                    // date: this.allergiesForm.date,
                };

                let successMessage = this.$i18n.t('message.allergyCreated');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('addAllergyVersion', {
                        args,
                        errorMessages,
                        successMessage
                    })
                    .then(() => {
                        // Scroll to the top of the page
                        // document.body.scrollTop = 0; // For Safari
                        // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        // this.$v.allergiesForm.date.$model = "";
                        this.$v.allergiesForm.description.$model = [];
                        // this.$v.allergiesForm.description.$invalid =false;
                        // this.$v.allergiesForm.date.$invalid = false;

                    });
            }
        },

        onAntecedentSubmit: function (evt) {
            evt.preventDefault();

            this.$v.antecedents.$touch();

            if (!this.$v.antecedents.$invalid) {
                let args = {
                    dossier_medical_id: this.generalConsultation.dossier.id,
                    type: this.antecedents.type,
                    description: this.antecedents.description,
                    date: this.antecedents.date
                };

                let successMessage = this.$i18n.t('message.antecedentCreated');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('createAntecedent', {
                        args,
                        errorMessages,
                        successMessage
                    })
                    .then(() => {

                        // // Scroll to the top of the page
                        // document.body.scrollTop = 0; // For Safari
                        // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

                        this.$v.antecedents.date.$model = '';
                        this.$v.antecedents.description.$model = '';
                        this.$v.antecedents.type.$model = '';

                        this.$v.antecedents.type.$invalid = false;
                        this.$v.antecedents.type.$dirty = false;

                        this.$v.antecedents.date.$invalid = false;

                        this.$v.antecedents.description.$invalid = false;
                    });
            }
        },

        onReset: function (evt) {
            evt.preventDefault();

            // Reset our form values
            this.form.dossier_medical_id = '';
            this.form.date_consultation = '';
            this.form.mode_de_vie = '';
            this.form.anamese = '';
            this.form.examen_clinique = '';
            this.form.complementaire = '';
            this.form.diagnostic_complementaire = '';
            this.form.traitement_propose = '';
            this.form.traitements = '';
            this.form.current_motifs = [''];

            // Trick to reset/clear native browser form validation state
            this.show = false;

            this.$nextTick(() => {
                this.show = true;
            });
        },

        getErrorsField(field) {
            if (this.errorshasField(field)) {
                return this.errors[field][0];
            } else {
                return '';
            }
        },

        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },

        clearErrorField(field) {
            this.$store.dispatch('clearErrorField', {
                field
            });

            this.getErrorsField(field);
        },
        getAnamnese: function () {
            return fetch(AppConfig.apiUrl + '/anamnese', {
                    method: 'GET',
                })
                .then(response => response.json())
                .then((json) => {
                     var groups = this.groupBy(json.anamnese);
                    groups = Object.fromEntries(
                                    Object.entries(groups).sort( (a,b) => a[1].length - b[1].length )    
                                )  
                    return groups;    
                });
        },
        getExamenClinic: function () {
            return fetch(AppConfig.apiUrl + '/examen-clinic', {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((json) => {
                     var groups = this.groupBy(json.examen);
                    groups = Object.fromEntries(
                                    Object.entries(groups).sort( (a,b) => a[1].length - b[1].length )    
                                )  
                    return groups;                  
                });
        },
         mobileComplementaire: function () {

            this.isInfo = false, 
            this.isAllergie=false, this.isAntecedent=false, this.isParam=false, this.isTraitement=false, this.isAnamnese=false, this.isXclinique = false, this.isXcomplement = true, this.isDiag = false, this.isCat = false, this.isRdv = false, this.dropHidden=false,
            this.getComplementaire()
        },
        mobileClinique: function () {

            this.isInfo = false, 
            this.isAllergie=false, this.isAntecedent=false, this.isParam=false, this.isTraitement=false, this.isAnamnese=false, this.isXclinique = true, this.isXcomplement = false, this.isDiag = false, this.isCat = false, this.isRdv = false, this.dropHidden=false,
            this.getExamenClinic()
        },
        getComplementaire: function () {
            return fetch(AppConfig.apiUrl + '/examen-complementaire', {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((json) => {
                    var groups = this.groupBy(json.examencomplementaire);
                    groups = Object.fromEntries(
                                    Object.entries(groups).sort( (a,b) => a[1].length - b[1].length )    
                                ) 
                    return groups;

                });
        },
        groupBy: function (collection) {
            const groups = collection.reduce((groups, item) => {
                const group = (groups[item.reference] || []);
                group.push(item);
                groups[item.reference] = group;
                
                return groups;
            }, {});
            return groups;
        },

        getConsultation: function() {
        let args = {
          consultation: this.$route.params.consultation
        };
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('getGeneralConsultation', { args, errorMessages })
      },
    },

    validations: {
        form: {
            practicien_id: {},
            ligne_de_temps_id: {},

            isConsultantDoctor: {

            },
            information: {

            },
            medecinSource: {

            },

            doctorName: {

            },
            contributors: {

            },
            current_motifs: {
                required
            },
            motifRdv: {

            },

            date_consultation: {
                required
            },

            mode_de_vie: {
                //
            },

            anamese: {
                //
            },
            anamnese: [],

            examens: [],
            complementaire: {
                //
            },
            complementaires: [],

            examen_clinique: {
                //
            },
            glycemie: {},
            glycated: {},
            cholestorol: {},
            ldl: {},
            hdl: {},
            // sop: {},
            // bmi:{},
            circonferenceAbdominal:{},
            circonferenceCranienne:{},
            deshydratation:{},
            malnutrition:{},
            tags: {},
            examen_complementaire: {
                //
            },

            traitement_propose: {
                //
            },
            diagnostic_complementaire: {
                //
            },

            conclusions: {
                //
            },

            profession: {},

            situation_familiale: {},

            nbre_enfant: {},

            tabac: {},

            nbreParJour: {},

            nbreAnnee: {},

            nbreCigarette: {
              //
            },
            alcool: {},

            autres: {},

            etablissement_id: {
                required
            },

            poids: {},

            taille: {},

            ta_systolique: {},

            ta_diastolique: {},

            temperature: {},

            frequence_cardiaque: {},

            frequence_respiratoire: {},

            sato2: {},
            traitements: {
                description: [],
                // date:''
            },

            documents: {
                // required
            },

            dateRdv: {},
            // motifRdv: {}
        },
        motifs: {},
        antecedents: {

            type: {
                required
            },

            description: {
                required,
                minLength: minLength(3)
            },

            date: {},
        },
        allergiesForm: {

            description: {
                required
            },

            date: {},
        },

    },

    mounted() {
        this.getTimelines();
        // Retrieve consultation
        this.getConsultation();
        // Fetch control doctor list
        this.getDoctors();

        // Fetch practitioner list
        this.getPractitioners();

        // Fetch user institution list
        this.getUserInstitutions();

        // Fetch institution list
        this.getInstitutions();
        // Retrieve list of medical documents

        // Fetch reason list
        this.getReasons();
        // Fetch allergy list
        this.getAllergies();

        this.getAnamnese().then((data) => {
            this.anamneses = data;
        });

        this.getExamenClinic().then((data) => {
            this.examens = data;
        });

        this.getComplementaire().then((data) => {
            this.complementaires = data;
        });


        var btn = $('#button');

        $(window).scroll(function () {
            if ($(window).scrollTop() > 300) {
                btn.addClass('show');
            } else {
                btn.removeClass('show');
            }
        });

        btn.on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, '300');
        });

    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);

        // Embedded Coding Tool settings object
        // please note that only the property "apiServerUrl" is required
        // the other properties are optional
        const mySettings = {
        // The API located at the URL below 
        // should be used only for software
        // development and testing. 
        // ICD content at this location might not
        // be up to date or complete. 
        // For production, use the API located at
        // id.who.int with proper OAUTH authentication
        apiServerUrl: "https://icd11restapi-developer-test.azurewebsites.net",
        height: "30vh"
        };

        // example of an Embedded Coding Tool using the callback selectedEntityFunction for copying the code selected in an html element
        const myCallbacks = {
            selectedEntityFunction: selectedEntity => {
                if(this.slectedIcd.some(item => item.code === selectedEntity.code)){
                    //alert("You ");
                } else{
                     this.slectedIcd.push(selectedEntity);
                }
                document.getElementById(
                "icd-paste-selected-" + selectedEntity.iNo
                ).innerHTML =
                selectedEntity.code + " - " + selectedEntity.bestMatchText;
                document.getElementById(
                "icd-selected-" + selectedEntity.iNo
                ).style.display =
                "inline";
            }
        };

        // configure all the Embedded Coding Tool
            ECT.Handler.configure(mySettings, myCallbacks);

            // overwrite configuration only for the Embedded Coding Tool 1
            ECT.Handler.overwriteConfiguration("1", {
            chaptersFilter: "01;02",
            wordsAvailable: false
        });
        if (localStorage.getItem('reload')==0) {
           
            localStorage.setItem('reload', 1);
            window.location.reload();
        }
    }
}
</script>

<style>
legend {
    color: black;
    font-weight: bold;
}

.bv-no-focus-ring .col-form-label .pt-0 {
    color: black;
    font-weight: bold;
}

legend {
    color: black;
    font-weight: bold;
}

.bv-no-focus-ring .col-form-label .pt-0 {
    color: black;
    font-weight: bold;
}

#icd-selected-1,
#icd-selected-2,
#icd-selected-3 {
  float: right;
  display: none;
}
#icd-paste-selected-1,
#icd-paste-selected-2,
#icd-paste-selected-3 {
 /* background-color: rgb(45 206 171);*/
  padding: 5px;
}

.icd-instance {
  border: 1px solid #ccc;
  margin-bottom: 40px;
  padding: 10px;
  background-color: #eee;
  border-radius: 0.25rem;
}
.icd {
  margin-top: 20px;
}
.icd::after {
  clear: both;
  content: "";
  display: block;
}
.icd-search {
  float: left;
  margin-bottom: 20px;
}
.icd input {
  /*width: 400px;
  height: 1.2rem;
  font-size: 0.9rem;
  padding-left: 4px;*/
}
.icd-clear {
  cursor: pointer;
  padding: 2px;
}
.icd-subtitle {
  font-size: 0.75rem;
  font-weight: normal;
  margin-left: 6px;
}
.ctw-window {
  background-color: #fff;
}

.ectComponent .circleicon {
    cursor: pointer;
    vertical-align: 1px;
}

.ectComponent .pacolor {
    background: #2dceab;
    border: 1px solid #ccc;
    padding-right: 3px!important;
    font-weight: 700;
}
.ectComponent .circleicon, .ectComponent .circleiconWithinDetails {
    font-size: 13.8px;
}
.icd input {
	margin:15px 0;
	padding:15px 10px;
	width:100%;
	outline:none;
	border:1px solid #bbb;
	border-radius:5px;
	display:inline-block;
	-webkit-box-sizing:border-box;
	-moz-box-sizing:border-box;
	box-sizing:border-box;
    -webkit-transition:0.2s ease all;
	-moz-transition:0.2s ease all;
	-ms-transition:0.2s ease all;
	-o-transition:0.2s ease all;
	transition:0.2s ease all;
}
.ectComponent .searchresults h4 {
    color: #2dcecc !important;
}
.ectComponent .showlink, .ectComponent .showlinkNormalSize {
    color: #00adb7!important;
}
.ectComponent .browser em.found, .ectComponent .browser em.found em.wbe, .ectComponent .entitylist em.found, .ectComponent .entitylist em.found em.wbe {
    font-weight: 700;
    font-style: normal;
    color: #2dcecc;
}
.ectComponent .browser em.nonwbe, .ectComponent .entitylist em.nonwbe {
    font-weight: 400;
    font-style: normal;
    color: #2dceab;
}
.ectComponent select {
    color: #42ada7;
}
.ectComponent .pvs {
    font-size: small;
    background-color: #a7a7a775;
}
.ectComponent .circleicon {
    display: none;
}
.table td, .table th {
    white-space: initial;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
